var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChakra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 149,
    viewBox: "0 0 149 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -8,
    y: -8,
    width: 165,
    height: 165
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(4px)",
      clipPath: "url(#bgblur_0_113_11492_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.7644 22.7854C82.1391 22.9981 84.7671 24.3202 84.281 27.9079C83.947 30.3726 82.768 31.4798 81.6633 32.5173C80.7579 33.3676 79.9024 34.171 79.6028 35.6364C79.5709 34.141 78.8733 33.1973 78.1351 32.1984C77.2343 30.9797 76.2729 29.679 76.3863 27.1944C76.5513 23.5776 79.3738 22.7481 80.7644 22.7854Z",
    fill: "url(#paint0_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6941 122.445C66.3453 122.104 63.8531 120.541 64.6739 117.015C65.2378 114.592 66.5156 113.601 67.7128 112.672C68.694 111.91 69.6211 111.19 70.0569 109.76C69.9483 111.251 70.5542 112.257 71.1955 113.32C71.9779 114.618 72.8129 116.003 72.4667 118.466C71.9629 122.052 69.075 122.613 67.6941 122.445Z",
    fill: "url(#paint1_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4872 26.1745C94.7601 26.7356 96.9564 28.6929 95.5582 32.0326C94.5977 34.3268 93.1723 35.0912 91.8367 35.8074C90.7421 36.3943 89.7078 36.949 89.0392 38.2869C89.3954 36.8342 88.9659 35.7421 88.5113 34.5862C87.9566 33.1758 87.3647 31.6706 88.1172 29.3C89.2127 25.8492 92.1537 25.7785 93.4872 26.1745Z",
    fill: "url(#paint2_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0685 119.055C53.854 118.377 51.8512 116.222 53.5567 113.029C54.7283 110.835 56.2192 110.207 57.6161 109.62C58.761 109.138 59.8428 108.683 60.6341 107.414C60.1431 108.827 60.4682 109.954 60.8122 111.148C61.232 112.604 61.6801 114.158 60.7083 116.448C59.2937 119.78 56.359 119.575 55.0685 119.055Z",
    fill: "url(#paint3_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.899 32.7157C105.984 33.5872 107.598 36.0462 105.383 38.9102C103.862 40.8777 102.287 41.2471 100.812 41.5932C99.6026 41.8769 98.46 42.1449 97.4679 43.2642C98.1879 41.9532 98.0557 40.7871 97.9157 39.553C97.745 38.0471 97.5628 36.44 98.9033 34.3449C100.855 31.2952 103.714 31.9881 104.899 32.7157Z",
    fill: "url(#paint4_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7503 112.488C42.7527 111.519 41.3758 108.919 43.8498 106.276C45.5494 104.46 47.1518 104.24 48.6532 104.034C49.8837 103.865 51.0464 103.705 52.1392 102.684C51.2993 103.922 51.3215 105.095 51.3449 106.337C51.3735 107.852 51.4041 109.469 49.8728 111.429C47.6438 114.282 44.8624 113.324 43.7503 112.488Z",
    fill: "url(#paint5_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.223 41.9635C115.045 43.0859 115.968 45.8791 113.087 48.0722C111.108 49.5788 109.492 49.5281 107.977 49.4806C106.735 49.4416 105.562 49.4048 104.314 50.2291C105.349 49.1492 105.523 47.9886 105.708 46.7603C105.932 45.2615 106.172 43.662 108.009 41.9853C110.684 39.5445 113.266 40.9538 114.223 41.9635Z",
    fill: "url(#paint6_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5108 103.191C33.7981 101.997 33.141 99.129 36.2149 97.2161C38.3265 95.9019 39.9312 96.1042 41.4348 96.2937C42.6671 96.4491 43.8315 96.5958 45.1514 95.8923C44.0198 96.8703 43.7375 98.0095 43.4387 99.215C43.0742 100.686 42.6852 102.256 40.6988 103.753C37.8074 105.932 35.3687 104.286 34.5108 103.191Z",
    fill: "url(#paint7_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.822 53.2874C121.326 54.5843 121.495 57.5213 118.145 58.8941C115.843 59.8372 114.295 59.3698 112.844 58.9318C111.655 58.5729 110.531 58.2337 109.112 58.707C110.391 57.9317 110.86 56.8557 111.356 55.7169C111.961 54.3274 112.607 52.8445 114.815 51.7004C118.03 50.0349 120.159 52.0645 120.822 53.2874Z",
    fill: "url(#paint8_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9797 91.7979C27.6004 90.4595 27.708 87.5197 31.1722 86.4674C33.552 85.7445 35.0497 86.3553 36.453 86.9275C37.6031 87.3965 38.6898 87.8397 40.1468 87.5017C38.8006 88.1535 38.2331 89.1808 37.6325 90.268C36.8997 91.5945 36.1176 93.0102 33.8115 93.942C30.4546 95.2983 28.525 93.0777 27.9797 91.7979Z",
    fill: "url(#paint9_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.248 65.9159C124.399 67.2989 123.802 70.1795 120.211 70.6385C117.743 70.9538 116.369 70.1015 115.081 69.303C114.025 68.6485 113.028 68.0301 111.535 68.12C112.971 67.7022 113.702 66.7841 114.476 65.8125C115.42 64.6269 116.427 63.3617 118.857 62.8281C122.393 62.0514 123.924 64.563 124.248 65.9159Z",
    fill: "url(#paint10_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.602 79.0848C24.582 77.6938 25.4468 74.8819 29.0653 74.7621C31.5511 74.6798 32.8397 75.6574 34.0471 76.5734C35.0366 77.324 35.9716 78.0334 37.4665 78.084C35.9974 78.3652 35.1834 79.2106 34.3219 80.1053C33.2707 81.1969 32.1488 82.362 29.6801 82.6651C26.0866 83.1064 24.7974 80.4621 24.602 79.0848Z",
    fill: "url(#paint11_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.267 78.9883C124.055 80.3631 122.732 82.9911 119.145 82.5049C116.68 82.171 115.573 80.9919 114.535 79.8872C113.685 78.9818 112.882 78.1264 111.416 77.8268C112.912 77.7949 113.855 77.0973 114.854 76.359C116.073 75.4583 117.374 74.4969 119.858 74.6102C123.475 74.7752 124.304 77.5977 124.267 78.9883Z",
    fill: "url(#paint12_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6078 65.9181C24.9485 64.5694 26.5116 62.0771 30.0378 62.898C32.4602 63.4619 33.4519 64.7396 34.3811 65.9369C35.1426 66.9181 35.8621 67.8452 37.2929 68.281C35.8012 68.1724 34.7961 68.7783 33.7324 69.4195C32.4344 70.2019 31.0492 71.0369 28.5862 70.6908C25.001 70.187 24.4401 67.2991 24.6078 65.9181Z",
    fill: "url(#paint13_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.878 91.7112C120.317 92.9841 118.36 95.1804 115.02 93.7822C112.726 92.8217 111.961 91.3963 111.245 90.0607C110.658 88.9661 110.104 87.9318 108.766 87.2632C110.218 87.6194 111.311 87.1899 112.466 86.7353C113.877 86.1806 115.382 85.5887 117.753 86.3412C121.203 87.4367 121.274 90.3777 120.878 91.7112Z",
    fill: "url(#paint14_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9975 53.2926C28.6757 52.0781 30.8305 50.0753 34.0241 51.7808C36.2181 52.9524 36.8452 54.4433 37.4329 55.8403C37.9145 56.9851 38.3696 58.0669 39.6388 58.8582C38.226 58.3672 37.0983 58.6923 35.9049 59.0363C34.4487 59.4561 32.8946 59.9042 30.6051 58.9324C27.2724 57.5178 27.478 54.5831 27.9975 53.2926Z",
    fill: "url(#paint15_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.337 103.123C113.465 104.208 111.006 105.822 108.142 103.608C106.175 102.086 105.806 100.511 105.459 99.0359C105.176 97.8266 104.908 96.6841 103.788 95.6919C105.099 96.412 106.266 96.2797 107.5 96.1398C109.006 95.9691 110.613 95.7868 112.708 97.1273C115.757 99.0786 115.065 101.938 114.337 103.123Z",
    fill: "url(#paint16_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5646 41.9745C35.534 40.9768 38.1338 39.6 40.7771 42.074C42.5931 43.7735 42.813 45.3759 43.0191 46.8774C43.188 48.1079 43.3476 49.2706 44.3688 50.3634C43.1312 49.5235 41.9578 49.5456 40.716 49.5691C39.2007 49.5977 37.5836 49.6282 35.6236 48.097C32.7706 45.868 33.7288 43.0866 34.5646 41.9745Z",
    fill: "url(#paint17_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.089 112.447C103.967 113.269 101.174 114.192 98.9805 111.311C97.4738 109.332 97.5246 107.716 97.5721 106.201C97.6111 104.96 97.6479 103.787 96.8235 102.539C97.9035 103.573 99.0641 103.747 100.292 103.932C101.791 104.157 103.391 104.396 105.067 106.233C107.508 108.908 106.099 111.49 105.089 112.447Z",
    fill: "url(#paint18_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8615 32.735C45.0561 32.0222 47.9236 31.3652 49.8366 34.439C51.1508 36.5507 50.9485 38.1554 50.759 39.659C50.6036 40.8913 50.4568 42.0557 51.1604 43.3756C50.1824 42.244 49.0432 41.9617 47.8376 41.6629C46.3666 41.2984 44.7967 40.9093 43.2998 38.923C41.1209 36.0315 42.7664 33.5929 43.8615 32.735Z",
    fill: "url(#paint19_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7652 119.046C92.4684 119.55 89.5314 119.719 88.1585 116.369C87.2154 114.067 87.6829 112.519 88.1208 111.068C88.4798 109.879 88.819 108.755 88.3457 107.336C89.121 108.615 90.197 109.084 91.3358 109.58C92.7253 110.185 94.2082 110.831 95.3523 113.039C97.0178 116.254 94.9882 118.383 93.7652 119.046Z",
    fill: "url(#paint20_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2547 26.2038C56.5931 25.8246 59.533 25.9321 60.5853 29.3963C61.3081 31.7761 60.6974 33.2738 60.1252 34.6771C59.6562 35.8272 59.213 36.9139 59.551 38.3709C58.8992 37.0247 57.8719 36.4572 56.7847 35.8566C55.4582 35.1238 54.0424 34.3417 53.1107 32.0356C51.7544 28.6787 53.9749 26.7491 55.2547 26.2038Z",
    fill: "url(#paint21_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1368 122.472C79.7538 122.623 76.8732 122.026 76.4142 118.435C76.0989 115.968 76.9511 114.593 77.7497 113.305C78.4042 112.249 79.0226 111.252 78.9326 109.759C79.3505 111.195 80.2686 111.926 81.2402 112.7C82.4257 113.644 83.691 114.651 84.2246 117.081C85.0013 120.617 82.4897 122.149 81.1368 122.472Z",
    fill: "url(#paint22_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9679 22.826C69.3588 22.8061 72.1707 23.6708 72.2905 27.2894C72.3728 29.7752 71.3952 31.0638 70.4793 32.2712C69.7286 33.2607 69.0193 34.1957 68.9686 35.6905C68.6874 34.2215 67.8421 33.4074 66.9474 32.5459C65.8557 31.4947 64.6906 30.3728 64.3875 27.9042C63.9462 24.3107 66.5905 23.0215 67.9679 22.826Z",
    fill: "url(#paint23_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.59 51.4374C76.5995 48.3882 77.7662 44.753 77.7662 40.85C77.7662 36.9471 76.5995 33.3118 74.59 30.2627C72.5806 33.3118 71.4138 36.9471 71.4138 40.85C71.4138 44.753 72.5806 48.3882 74.59 51.4374Z",
    fill: "url(#paint24_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.59 114.961C76.5995 111.912 77.7662 108.277 77.7662 104.374C77.7662 100.471 76.5995 96.836 74.59 93.7868C72.5806 96.836 71.4138 100.471 71.4138 104.374C71.4138 108.277 72.5806 111.912 74.59 114.961Z",
    fill: "url(#paint25_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0705 52.1589C82.8006 49.7337 84.8685 46.5243 85.8786 42.7544C86.8888 38.9844 86.7027 35.1711 85.5509 31.7057C82.8207 34.1309 80.7528 37.3403 79.7427 41.1103C78.7325 44.8802 78.9186 48.6936 80.0705 52.1589Z",
    fill: "url(#paint26_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6292 113.518C66.3594 111.093 68.4273 107.884 69.4374 104.114C70.4476 100.344 70.2615 96.5306 69.1097 93.0653C66.3795 95.4905 64.3116 98.6998 63.3015 102.47C62.2913 106.24 62.4774 110.053 63.6292 113.518Z",
    fill: "url(#paint27_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1775 54.2742C88.4423 52.6383 91.2703 50.0735 93.2218 46.6934C95.1733 43.3134 95.9805 39.5818 95.7648 35.9365C92.5 37.5723 89.6719 40.1372 87.7204 43.5173C85.769 46.8973 84.9618 50.6289 85.1775 54.2742Z",
    fill: "url(#paint28_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4154 109.288C56.6802 107.652 59.5082 105.087 61.4597 101.707C63.4112 98.3269 64.2184 94.5953 64.0027 90.95C60.7379 92.5859 57.9099 95.1507 55.9584 98.5308C54.0069 101.911 53.1997 105.642 53.4154 109.288Z",
    fill: "url(#paint29_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5629 57.6393C93.1399 56.9041 96.5354 55.1586 99.2952 52.3988C102.055 49.639 103.8 46.2435 104.536 42.6665C100.959 43.4017 97.5632 45.1472 94.8034 47.907C92.0435 50.6668 90.2981 54.0623 89.5629 57.6393Z",
    fill: "url(#paint30_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6445 102.558C48.2215 101.822 51.617 100.077 54.3768 97.3172C57.1366 94.5574 58.8821 91.1619 59.6172 87.5849C56.0403 88.3201 52.6448 90.0655 49.8849 92.8254C47.1251 95.5852 45.3796 98.9807 44.6445 102.558Z",
    fill: "url(#paint31_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9279 62.0247C96.5733 62.2404 100.305 61.4332 103.685 59.4817C107.065 57.5303 109.63 54.7022 111.266 51.4374C107.62 51.2217 103.889 52.0289 100.509 53.9804C97.1286 55.9319 94.5638 58.7599 92.9279 62.0247Z",
    fill: "url(#paint32_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9144 93.7868C41.5598 94.0025 45.2913 93.1953 48.6714 91.2438C52.0515 89.2923 54.6163 86.4643 56.2522 83.1995C52.6068 82.9838 48.8753 83.791 45.4952 85.7425C42.1151 87.6939 39.5503 90.522 37.9144 93.7868Z",
    fill: "url(#paint33_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0433 67.1316C98.5086 68.2835 102.322 68.4696 106.092 67.4594C109.862 66.4493 113.071 64.3814 115.496 61.6513C112.031 60.4994 108.218 60.3133 104.448 61.3235C100.678 62.3336 97.4684 64.4015 95.0433 67.1316Z",
    fill: "url(#paint34_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6836 83.5729C37.149 84.7247 40.9623 84.9108 44.7323 83.9007C48.5023 82.8905 51.7116 80.8227 54.1368 78.0925C50.6715 76.9407 46.8581 76.7546 43.0881 77.7647C39.3182 78.7749 36.1088 80.8427 33.6836 83.5729Z",
    fill: "url(#paint35_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7648 72.6121C98.8139 74.6216 102.449 75.7883 106.352 75.7883C110.255 75.7883 113.89 74.6216 116.939 72.6121C113.89 70.6026 110.255 69.4359 106.352 69.4359C102.449 69.4359 98.8139 70.6026 95.7648 72.6121Z",
    fill: "url(#paint36_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2407 72.6121C35.2898 74.6216 38.925 75.7883 42.828 75.7883C46.731 75.7883 50.3662 74.6216 53.4153 72.6121C50.3662 70.6026 46.731 69.4359 42.828 69.4359C38.925 69.4359 35.2898 70.6026 32.2407 72.6121Z",
    fill: "url(#paint37_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0433 78.0925C97.4684 80.8227 100.678 82.8905 104.448 83.9007C108.218 84.9109 112.031 84.7247 115.496 83.5729C113.071 80.8427 109.862 78.7749 106.092 77.7647C102.322 76.7546 98.5086 76.9407 95.0433 78.0925Z",
    fill: "url(#paint38_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6837 61.6512C36.1088 64.3814 39.3182 66.4493 43.0882 67.4594C46.8582 68.4696 50.6715 68.2835 54.1368 67.1317C51.7117 64.4015 48.5023 62.3336 44.7323 61.3235C40.9623 60.3133 37.149 60.4994 33.6837 61.6512Z",
    fill: "url(#paint39_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9201 83.2153C94.557 86.475 97.1223 89.299 100.502 91.2485C103.882 93.198 107.613 94.0053 111.257 93.7916C109.62 90.5319 107.055 87.7078 103.675 85.7584C100.295 83.8089 96.5644 83.0016 92.9201 83.2153Z",
    fill: "url(#paint40_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9086 51.4862C39.5454 54.7459 42.1107 57.57 45.4907 59.5194C48.8706 61.4689 52.6015 62.2762 56.2457 62.0625C54.6088 58.8028 52.0435 55.9787 48.6636 54.0293C45.2836 52.0798 41.5528 51.2725 37.9086 51.4862Z",
    fill: "url(#paint41_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5579 87.6009C90.2953 91.1732 92.0423 94.565 94.8025 97.3228C97.5627 100.081 100.957 101.826 104.533 102.563C103.795 98.9906 102.048 95.5988 99.2882 92.841C96.528 90.0832 93.1333 88.3377 89.5579 87.6009Z",
    fill: "url(#paint42_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.633 42.7149C45.3704 46.2872 47.1174 49.679 49.8776 52.4368C52.6378 55.1947 56.0326 56.9401 59.6079 57.6769C58.8705 54.1046 57.1235 50.7128 54.3633 47.955C51.6031 45.1972 48.2083 43.4517 44.633 42.7149Z",
    fill: "url(#paint43_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1752 90.9669C84.9629 94.6083 85.7725 98.3367 87.7249 101.715C89.6773 105.093 92.5046 107.658 95.7674 109.295C95.9797 105.653 95.1701 101.925 93.2177 98.5468C91.2653 95.1686 88.438 92.6039 85.1752 90.9669Z",
    fill: "url(#paint44_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3984 35.983C53.1861 39.6244 53.9957 43.3527 55.9481 46.731C57.9005 50.1092 60.7278 52.6739 63.9907 54.3109C64.2029 50.6695 63.3934 46.9411 61.441 43.5629C59.4886 40.1846 56.6613 37.62 53.3984 35.983Z",
    fill: "url(#paint45_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0706 93.0839C78.9231 96.5463 78.7402 100.357 79.7517 104.126C80.7632 107.894 82.8304 111.103 85.5583 113.529C86.7059 110.066 86.8888 106.256 85.8773 102.487C84.8658 98.7186 82.7986 95.5096 80.0706 93.0839Z",
    fill: "url(#paint46_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6075 31.749C62.46 35.2114 62.277 39.0223 63.2885 42.7908C64.3 46.5592 66.3672 49.7682 69.0952 52.1939C70.2427 48.7316 70.4257 44.9207 69.4142 41.1522C68.4027 37.3838 66.3355 34.1748 63.6075 31.749Z",
    fill: "url(#paint47_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3511 21.2657C73.4876 23.6918 74.3533 25.7492 74.5191 26.4746C75.687 23.7513 75.3772 24.9462 77.8379 20.8657C79.8064 17.6014 79.407 14.4633 78.9613 13.3022C78.595 12.4284 77.5359 10.3264 76.2296 8.90962C74.9232 7.49284 74.1912 5.12184 73.9885 4.11343C73.6945 6.4705 73.0919 8.02377 71.8444 9.57872C70.8463 10.8227 70.0862 12.8463 69.8308 13.7027C69.4474 15.2128 69.2145 18.8396 71.3511 21.2657Z",
    fill: "url(#paint48_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3511 137.091C73.4876 139.518 74.3533 141.575 74.5191 142.3C75.687 139.577 75.3772 140.772 77.8379 136.691C79.8064 133.427 79.407 130.289 78.9613 129.128C78.595 128.254 77.5359 126.152 76.2296 124.735C74.9232 123.319 74.1912 120.948 73.9885 119.939C73.6945 122.296 73.0919 123.849 71.8444 125.404C70.8463 126.648 70.0862 128.672 69.8308 129.528C69.4474 131.038 69.2145 134.665 71.3511 137.091Z",
    fill: "url(#paint49_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9077 22.2222C86.3435 25.1186 86.6473 27.3299 86.6196 28.0735C88.4526 25.7453 87.8441 26.8193 91.277 23.5148C94.0233 20.8711 94.4497 17.7366 94.3197 16.4997C94.1921 15.5608 93.7131 13.2564 92.818 11.5498C91.9228 9.84318 91.8294 7.36351 91.8946 6.337C91.0006 8.53765 90.0165 9.88203 88.409 11.0611C87.123 12.0044 85.865 13.7623 85.3967 14.5234C84.6355 15.8828 83.4719 19.3258 84.9077 22.2222Z",
    fill: "url(#paint50_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9299 134.101C56.3657 136.998 56.6694 139.209 56.6418 139.952C58.4748 137.624 57.8662 138.698 61.2991 135.394C64.0455 132.75 64.4719 129.616 64.3418 128.379C64.2142 127.44 63.7353 125.135 62.8401 123.429C61.945 121.722 61.8516 119.242 61.9168 118.216C61.0228 120.417 60.0387 121.761 58.4312 122.94C57.1452 123.883 55.8872 125.641 55.4189 126.402C54.6576 127.762 53.4941 131.205 54.9299 134.101Z",
    fill: "url(#paint51_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7549 26.6548C98.3921 29.8241 98.1132 32.0387 97.8941 32.7498C100.267 30.9753 99.4014 31.8552 103.573 29.5518C106.91 27.7091 108.133 24.7917 108.327 23.5633C108.447 22.6234 108.581 20.2735 108.158 18.3933C107.735 16.5132 108.286 14.0939 108.615 13.1192C107.182 15.0135 105.883 16.0574 104.026 16.7802C102.539 17.3585 100.869 18.7309 100.22 19.3449C99.1327 20.461 97.1176 23.4855 97.7549 26.6548Z",
    fill: "url(#paint52_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8422 126.963C40.4794 130.132 40.2005 132.347 39.9813 133.058C42.3544 131.283 41.4886 132.163 45.6598 129.86C48.9968 128.017 50.22 125.1 50.4145 123.871C50.5343 122.931 50.668 120.581 50.2451 118.701C49.8222 116.821 50.3737 114.402 50.7024 113.427C49.2692 115.321 47.9707 116.365 46.1129 117.088C44.6265 117.666 42.9564 119.039 42.3071 119.653C41.2199 120.769 39.2049 123.793 39.8422 126.963Z",
    fill: "url(#paint53_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.017 34.2614C108.812 37.4877 107.97 39.5546 107.574 40.1848C110.325 39.0849 109.261 39.7108 113.887 38.5654C117.587 37.6492 119.523 35.1478 120.029 34.0116C120.388 33.1347 121.126 30.8995 121.204 28.974C121.282 27.0484 122.441 24.8543 123.01 23.9979C121.136 25.4567 119.611 26.1289 117.63 26.3463C116.044 26.5202 114.076 27.4136 113.29 27.8386C111.951 28.6353 109.222 31.0352 109.017 34.2614Z",
    fill: "url(#paint54_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.116 116.163C26.9112 119.389 26.0686 121.456 25.6729 122.086C28.4244 120.986 27.3604 121.612 31.9856 120.467C35.6858 119.55 37.6224 117.049 38.1282 115.913C38.4872 115.036 39.2246 112.801 39.3027 110.875C39.3808 108.95 40.5397 106.755 41.1094 105.899C39.2349 107.358 37.7104 108.03 35.7288 108.247C34.1434 108.421 32.175 109.315 31.3889 109.74C30.0499 110.536 27.3207 112.936 27.116 116.163Z",
    fill: "url(#paint55_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.927 44.5238C116.894 47.5871 115.545 49.3655 115 49.8718C117.942 49.5215 116.752 49.8507 121.516 49.9415C125.328 50.0141 127.846 48.0992 128.628 47.1326C129.202 46.3785 130.493 44.4103 131.067 42.5706C131.64 40.7309 133.328 38.9115 134.1 38.2317C131.911 39.1556 130.265 39.4104 128.295 39.1074C126.718 38.8651 124.586 39.2186 123.716 39.4257C122.217 39.8486 118.959 41.4604 117.927 44.5238Z",
    fill: "url(#paint56_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6187 102.437C16.5859 105.5 15.2371 107.278 14.6918 107.785C17.6342 107.434 16.4444 107.764 21.2085 107.854C25.0198 107.927 27.5378 106.012 28.3204 105.046C28.8941 104.291 30.1849 102.323 30.7587 100.484C31.3325 98.6438 33.0198 96.8244 33.7918 96.1447C31.6035 97.0686 29.957 97.3233 27.9866 97.0204C26.4103 96.778 24.2777 97.1315 23.4084 97.3386C21.9089 97.7616 18.6515 99.3733 17.6187 102.437Z",
    fill: "url(#paint57_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.877 56.7424C122.086 59.4341 120.323 60.8028 119.665 61.1506C122.598 61.5739 121.364 61.5839 125.942 62.9046C129.605 63.9612 132.532 62.7632 133.538 62.0322C134.288 61.4522 136.044 59.8852 137.074 58.2567C138.105 56.6282 140.206 55.3074 141.127 54.8506C138.774 55.1767 137.118 54.9967 135.293 54.1941C133.833 53.552 131.682 53.3415 130.789 53.3165C129.231 53.3369 125.667 54.0507 123.877 56.7424Z",
    fill: "url(#paint58_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9977 86.7204C10.2072 89.4121 8.44407 90.7807 7.78629 91.1286C10.7191 91.5519 9.48469 91.5619 14.0629 92.8826C17.7255 93.9392 20.6534 92.7412 21.6595 92.0101C22.4088 91.4302 24.165 89.8632 25.1954 88.2347C26.2258 86.6061 28.3266 85.2854 29.2482 84.8286C26.8953 85.1547 25.239 84.9746 23.4142 84.172C21.9543 83.53 19.8028 83.3195 18.9096 83.2945C17.3516 83.3149 13.7882 84.0287 11.9977 86.7204Z",
    fill: "url(#paint59_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.461 70.0847C124.035 72.2213 121.978 73.087 121.253 73.2527C123.976 74.4206 122.781 74.1108 126.861 76.5715C130.126 78.54 133.264 78.1406 134.425 77.6949C135.299 77.3286 137.401 76.2695 138.818 74.9632C140.234 73.6569 142.605 72.9249 143.614 72.7221C141.257 72.4281 139.703 71.8255 138.148 70.578C136.905 69.5799 134.881 68.8198 134.025 68.5644C132.514 68.181 128.888 67.9482 126.461 70.0847Z",
    fill: "url(#paint60_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6358 70.0848C8.20972 72.2214 6.15238 73.0871 5.42698 73.2528C8.15029 74.4207 6.95537 74.1109 11.0358 76.5716C14.3001 78.5401 17.4383 78.1407 18.5993 77.695C19.4732 77.3287 21.5752 76.2696 22.9919 74.9633C24.4087 73.657 26.7797 72.925 27.7881 72.7223C25.431 72.4282 23.8778 71.8256 22.3228 70.5781C21.0789 69.58 19.0552 68.8199 18.1989 68.5646C16.6887 68.1811 13.0619 67.9483 10.6358 70.0848Z",
    fill: "url(#paint61_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.505 83.6414C122.609 85.0772 120.397 85.3809 119.654 85.3533C121.982 87.1863 120.908 86.5777 124.212 90.0106C126.856 92.757 129.991 93.1834 131.227 93.0533C132.166 92.9257 134.471 92.4468 136.177 91.5516C137.884 90.6565 140.364 90.5631 141.39 90.6283C139.19 89.7342 137.845 88.7502 136.666 87.1427C135.723 85.8567 133.965 84.5987 133.204 84.1304C131.844 83.3691 128.401 82.2056 125.505 83.6414Z",
    fill: "url(#paint62_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.626 53.6636C10.7296 55.0994 8.51831 55.4031 7.77471 55.3755C10.103 57.2085 9.02894 56.5999 12.3335 60.0328C14.9771 62.7792 18.1117 63.2056 19.3485 63.0756C20.2874 62.948 22.5918 62.469 24.2984 61.5739C26.0051 60.6787 28.4847 60.5853 29.5112 60.6505C27.3106 59.7565 25.9662 58.7724 24.7871 57.1649C23.8439 55.8789 22.0859 54.6209 21.3248 54.1526C19.9654 53.3913 16.5224 52.2278 13.626 53.6636Z",
    fill: "url(#paint63_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.072 96.4885C117.903 97.1258 115.689 96.8468 114.977 96.6277C116.752 99.0008 115.872 98.135 118.175 102.306C120.018 105.643 122.936 106.866 124.164 107.061C125.104 107.181 127.454 107.314 129.334 106.892C131.214 106.469 133.633 107.02 134.608 107.349C132.714 105.916 131.67 104.617 130.947 102.759C130.369 101.273 128.996 99.6028 128.382 98.9535C127.266 97.8663 124.242 95.8513 121.072 96.4885Z",
    fill: "url(#paint64_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7645 38.5758C17.5951 39.2131 15.3806 38.9341 14.6695 38.715C16.444 41.0881 15.564 40.2223 17.8675 44.3935C19.7102 47.7305 22.6276 48.9537 23.856 49.1482C24.7959 49.2679 27.1458 49.4017 29.0259 48.9788C30.906 48.5558 33.3254 49.1074 34.3001 49.4361C32.4058 48.0029 31.3619 46.7044 30.6391 44.8465C30.0608 43.3602 28.6883 41.6901 28.0744 41.0408C26.9583 39.9536 23.9338 37.9386 20.7645 38.5758Z",
    fill: "url(#paint65_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.466 107.751C110.24 107.546 108.173 106.703 107.542 106.308C108.642 109.059 108.016 107.995 109.162 112.62C110.078 116.321 112.579 118.257 113.716 118.763C114.593 119.122 116.828 119.859 118.753 119.937C120.679 120.016 122.873 121.174 123.729 121.744C122.271 119.87 121.598 118.345 121.381 116.363C121.207 114.778 120.314 112.81 119.889 112.024C119.092 110.685 116.692 107.955 113.466 107.751Z",
    fill: "url(#paint66_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5646 25.8497C28.3383 25.645 26.2714 24.8023 25.6413 24.4066C26.7411 27.1581 26.1153 26.0941 27.2606 30.7194C28.1769 34.4196 30.6783 36.3562 31.8145 36.8619C32.6914 37.2209 34.9266 37.9583 36.8521 38.0364C38.7776 38.1145 40.9718 39.2734 41.8282 39.8432C40.3694 37.9686 39.6971 36.4441 39.4798 34.4625C39.3059 32.8771 38.4125 30.9087 37.9875 30.1226C37.1908 28.7836 34.7909 26.0545 31.5646 25.8497Z",
    fill: "url(#paint67_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.203 116.66C100.14 115.628 98.3617 114.279 97.8554 113.733C98.2056 116.676 97.8765 115.486 97.7857 120.25C97.7131 124.061 99.628 126.579 100.595 127.362C101.349 127.936 103.317 129.227 105.157 129.8C106.996 130.374 108.816 132.061 109.495 132.833C108.572 130.645 108.317 128.999 108.62 127.028C108.862 125.452 108.509 123.319 108.302 122.45C107.879 120.95 106.267 117.693 103.203 116.66Z",
    fill: "url(#paint68_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2906 16.3525C42.2272 15.3197 40.4488 13.9709 39.9426 13.4255C40.2928 16.3679 39.9636 15.1782 39.8729 19.9423C39.8002 23.7535 41.7152 26.2716 42.6817 27.0542C43.4358 27.6279 45.404 28.9187 47.2437 29.4925C49.0834 30.0663 50.9029 31.7536 51.5826 32.5256C50.6587 30.3373 50.4039 28.6908 50.7069 26.7204C50.9492 25.1441 50.5957 23.0114 50.3887 22.1422C49.9657 20.6426 48.3539 17.3853 45.2906 16.3525Z",
    fill: "url(#paint69_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9848 122.61C88.2931 120.82 86.9244 119.057 86.5765 118.399C86.1533 121.332 86.1433 120.097 84.8225 124.676C83.766 128.338 84.964 131.266 85.695 132.272C86.275 133.021 87.842 134.778 89.4705 135.808C91.099 136.838 92.4197 138.939 92.8765 139.861C92.5505 137.508 92.7305 135.852 93.5331 134.027C94.1752 132.567 94.3857 130.415 94.4107 129.522C94.3902 127.964 93.6764 124.401 90.9848 122.61Z",
    fill: "url(#paint70_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0068 10.7315C58.3152 8.94101 56.9465 7.17783 56.5986 6.52005C56.1753 9.45285 56.1653 8.21846 54.8446 12.7967C53.788 16.4593 54.986 19.3872 55.7171 20.3933C56.297 21.1426 57.864 22.8988 59.4926 23.9292C61.1211 24.9596 62.4418 27.0603 62.8986 27.9819C62.5725 25.6291 62.7526 23.9728 63.5552 22.1479C64.1973 20.688 64.4078 18.5366 64.4327 17.6433C64.4123 16.0854 63.6985 12.5219 61.0068 10.7315Z",
    fill: "url(#paint71_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4721 8.75129C83.6658 11.1029 82.6852 13.3767 82.5457 14.2197C82.3989 13.0095 81.6946 10.1492 80.0521 8.38885C78.4096 6.62851 77.5682 3.80875 77.2799 2.63837C77.1951 1.68547 77.965 0.160676 79.3072 0.41827C80.6493 0.675865 80.8662 2.05555 80.8069 2.71319C80.7252 3.25503 80.613 4.62954 80.8179 5.79283C81.0229 6.95612 81.5129 8.44622 81.7324 9.04585C82.0007 9.85558 82.539 12.024 82.5457 14.2197C82.807 12.0219 84.281 9.2451 84.9854 8.13144C85.1979 7.83771 85.7602 7.02239 86.3098 6.11095C86.8594 5.19951 87.0742 3.87145 87.1128 3.32135C87.283 2.55117 87.9691 1.09059 89.353 1.40972C90.7368 1.72884 90.683 3.42676 90.4832 4.23583C90.3154 4.76116 89.2784 6.39971 86.4721 8.75129Z",
    fill: "url(#paint72_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0565 5.66968C83.6934 8.03066 82.8903 11.0299 82.6592 12.2343C82.8964 9.60378 82.4741 8.31848 82.173 6.0529C81.9321 4.24044 82.1223 2.85415 82.2132 2.38097L82.3601 1.94085C83.4394 0.221213 84.7469 0.659479 85.2657 1.09357C85.7639 1.6352 86.4195 3.3087 85.0565 5.66968Z",
    fill: "url(#paint73_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5803 140.363C65.3523 137.971 66.2998 135.683 66.4271 134.838C66.5914 136.046 67.3371 138.896 69.0048 140.632C70.6726 142.369 71.5548 145.176 71.86 146.342C71.9585 147.294 71.2107 148.83 69.865 148.591C68.5193 148.353 68.2824 146.977 68.3322 146.318C68.4061 145.775 68.4983 144.399 68.2766 143.239C68.0549 142.079 67.5433 140.596 67.3152 140C67.0352 139.194 66.4656 137.034 66.4271 134.838C66.1977 137.04 64.7639 139.837 64.0758 140.961C63.8676 141.258 63.3171 142.081 62.7807 143.001C62.2444 143.92 62.0489 145.251 62.0181 145.802C61.8592 146.574 61.1942 148.044 59.8059 147.745C58.4175 147.446 58.4468 145.748 58.6349 144.936C58.7951 144.408 59.8083 142.755 62.5803 140.363Z",
    fill: "url(#paint74_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0403 143.424C65.369 141.043 66.1287 138.033 66.3424 136.825C66.1432 139.459 66.5841 140.738 66.9179 142.999C67.185 144.808 67.0149 146.196 66.9309 146.671L66.7904 147.113C65.736 148.848 64.4223 148.429 63.8973 148.002C63.3913 147.468 62.7116 145.804 64.0403 143.424Z",
    fill: "url(#paint75_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.082 14.07C99.763 15.6152 98.2274 17.5577 97.8745 18.3359C98.0458 17.129 98.1058 14.1838 96.9749 12.0583C95.8441 9.93288 95.7611 6.9914 95.7855 5.78629C95.9503 4.84394 97.0886 3.57036 98.3184 4.16655C99.5481 4.76274 99.4005 6.15154 99.173 6.77142C98.9539 7.27366 98.4898 8.5723 98.3866 9.74899C98.2835 10.9257 98.3712 12.4918 98.4279 13.1278C98.4775 13.9794 98.4362 16.2132 97.8745 18.3359C98.6957 16.2806 100.838 13.9799 101.807 13.0865C102.088 12.8578 102.842 12.2158 103.609 11.4777C104.376 10.7395 104.927 9.5123 105.107 8.99096C105.47 8.29105 106.511 7.05784 107.765 7.72426C109.019 8.39067 108.528 10.0168 108.125 10.7466C107.827 11.2106 106.402 12.5249 103.082 14.07Z",
    fill: "url(#paint76_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.513 10.727C100.585 12.6548 99.0329 15.344 98.4979 16.4476C99.4079 13.968 99.3326 12.6172 99.6282 10.3509C99.8646 8.53786 100.407 7.24805 100.617 6.81449L100.873 6.42739C102.361 5.04571 103.51 5.80744 103.899 6.36102C104.24 7.01313 104.44 8.79929 102.513 10.727Z",
    fill: "url(#paint77_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.941 135.013C49.2376 133.42 50.745 131.456 51.0866 130.673C50.9327 131.882 50.9154 134.828 52.0769 136.937C53.2384 139.045 53.3639 141.985 53.3569 143.191C53.2058 144.135 52.086 145.425 50.8478 144.847C49.6096 144.269 49.737 142.878 49.9555 142.255C50.1674 141.749 50.6127 140.444 50.6988 139.266C50.7849 138.088 50.6745 136.523 50.6086 135.888C50.5467 135.037 50.5556 132.803 51.0866 130.673C50.2953 132.74 48.1863 135.071 47.2307 135.978C46.9528 136.211 46.2079 136.864 45.4519 137.613C44.6959 138.362 44.1626 139.597 43.9904 140.121C43.6369 140.826 42.614 142.074 41.3504 141.426C40.0868 140.778 40.5546 139.145 40.9465 138.409C41.2378 137.941 42.6444 136.606 45.941 135.013Z",
    fill: "url(#paint78_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5591 138.348C48.4587 136.392 49.9716 133.681 50.4906 132.57C49.6165 135.062 49.7114 136.412 49.4486 138.682C49.2385 140.498 48.7146 141.796 48.5107 142.233L48.2605 142.623C46.793 144.026 45.6327 143.281 45.2359 142.733C44.8855 142.086 44.6596 140.303 46.5591 138.348Z",
    fill: "url(#paint79_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.75 23.5131C114.144 24.1465 112.158 25.6254 111.616 26.2857C112.094 25.1643 112.914 22.335 112.372 19.9892C111.829 17.6435 112.511 14.7808 112.846 13.6231C113.249 12.7555 114.678 11.8199 115.712 12.7141C116.745 13.6082 116.243 14.9115 115.863 15.4514C115.522 15.8798 114.737 17.0141 114.333 18.124C113.929 19.2339 113.608 20.7694 113.498 21.3984C113.326 22.2338 112.708 24.3808 111.616 26.2857C112.941 24.513 115.606 22.8453 116.773 22.233C117.104 22.0848 117.998 21.6599 118.93 21.1454C119.862 20.6309 120.712 19.5881 121.02 19.131C121.553 18.5491 122.877 17.6273 123.916 18.5956C124.955 19.5639 124.059 21.0074 123.482 21.6082C123.074 21.9792 121.356 22.8798 117.75 23.5131Z",
    fill: "url(#paint80_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.065 20.1366C115.704 21.4997 113.509 23.6956 112.707 24.6231C114.228 22.4636 114.504 21.1393 115.376 19.0267C116.074 17.3366 116.932 16.2312 117.247 15.8668L117.594 15.5591C119.389 14.6095 120.302 15.6428 120.534 16.2782C120.695 16.9963 120.426 18.7734 118.065 20.1366Z",
    fill: "url(#paint81_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2536 125.546C34.8502 124.861 36.8147 123.353 37.3474 122.685C36.8857 123.813 36.1066 126.654 36.6827 128.992C37.2588 131.329 36.6192 134.202 36.3004 135.364C35.9099 136.238 34.4945 137.194 33.4481 136.315C32.4018 135.435 32.8848 134.125 33.2572 133.58C33.5926 133.146 34.3605 132.001 34.7486 130.885C35.1367 129.77 35.4351 128.23 35.5358 127.599C35.6962 126.761 36.283 124.606 37.3474 122.685C36.048 124.477 33.4075 126.183 32.2496 126.812C31.9209 126.965 31.0325 127.403 30.1083 127.931C29.1842 128.459 28.3494 129.514 28.0475 129.975C27.5235 130.565 26.2125 131.506 25.1597 130.552C24.1069 129.599 24.9815 128.143 25.5504 127.534C25.9529 127.157 27.657 126.232 31.2536 125.546Z",
    fill: "url(#paint82_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9877 128.927C33.3286 127.53 35.4917 125.302 36.2806 124.363C34.7913 126.545 34.5336 127.873 33.6922 129.998C33.0191 131.698 32.1773 132.815 31.8674 133.184L31.5245 133.497C29.7439 134.473 28.8159 133.453 28.5745 132.821C28.4035 132.105 28.6467 130.324 30.9877 128.927Z",
    fill: "url(#paint83_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.477 36.437C125.829 36.1155 123.528 37.0299 122.833 37.5274C123.585 36.5678 125.11 34.0472 125.193 31.6411C125.277 29.235 126.675 26.6461 127.299 25.6146C127.913 24.8809 129.536 24.3472 130.303 25.4783C131.069 26.6095 130.247 27.7385 129.74 28.1615C129.299 28.4869 128.248 29.3795 127.57 30.347C126.893 31.3145 126.186 32.7146 125.917 33.2938C125.534 34.0561 124.381 35.97 122.833 37.5274C124.572 36.158 127.578 35.2369 128.864 34.9475C129.222 34.89 130.196 34.7111 131.229 34.4553C132.262 34.1994 133.353 33.4122 133.769 33.0505C134.434 32.6262 135.952 32.0787 136.705 33.2829C137.458 34.487 136.219 35.6496 135.506 36.0804C135.016 36.3332 133.124 36.7586 129.477 36.437Z",
    fill: "url(#paint84_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.655 33.257C128.021 33.9627 125.333 35.5155 124.318 36.2038C126.345 34.5115 126.956 33.304 128.345 31.489C129.456 30.0371 130.571 29.1914 130.97 28.921L131.385 28.7137C133.364 28.2609 133.978 29.4954 134.038 30.1692C134.008 30.9044 133.288 32.5513 130.655 33.257Z",
    fill: "url(#paint85_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.519 112.606C23.1705 112.875 25.4582 111.927 26.1456 111.42C25.4077 112.39 23.9198 114.933 23.8713 117.34C23.8228 119.747 22.4615 122.356 21.8528 123.396C21.2496 124.139 19.6348 124.696 18.8517 123.576C18.0685 122.456 18.8743 121.315 19.3751 120.885C19.8112 120.553 20.8494 119.645 21.5131 118.668C22.1767 117.691 22.8635 116.281 23.1239 115.698C23.4957 114.93 24.6205 113 26.1456 111.42C24.4268 112.814 21.4347 113.779 20.1535 114.087C19.7964 114.149 18.8249 114.342 17.7956 114.613C16.7663 114.884 15.6869 115.687 15.2758 116.055C14.6172 116.488 13.1072 117.058 12.337 115.865C11.5668 114.672 12.7885 113.491 13.4956 113.05C13.982 112.79 15.8676 112.338 19.519 112.606Z",
    fill: "url(#paint86_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3871 115.803C21.0099 115.059 23.6758 113.468 24.6809 112.765C22.6777 114.486 22.085 115.703 20.7224 117.537C19.6322 119.005 18.5298 119.867 18.1349 120.143L17.7229 120.356C15.7504 120.838 15.118 119.612 15.0484 118.94C15.0685 118.204 15.7644 116.547 18.3871 115.803Z",
    fill: "url(#paint87_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.462 51.961C134.022 50.7064 131.563 50.9941 130.763 51.2948C131.737 50.5626 133.862 48.5224 134.566 46.2199C135.269 43.9173 137.29 41.7787 138.16 40.9438C138.942 40.394 140.648 40.2984 141.096 41.5895C141.544 42.8806 140.457 43.7583 139.858 44.0357C139.348 44.2359 138.102 44.826 137.197 45.5851C136.292 46.3442 135.246 47.5137 134.837 48.0035C134.27 48.6408 132.661 50.1911 130.763 51.2948C132.797 50.4222 135.939 50.3104 137.255 50.3635C137.616 50.4007 138.603 50.48 139.667 50.5003C140.731 50.5205 141.989 50.0425 142.485 49.8009C143.237 49.5631 144.845 49.4271 145.26 50.7851C145.676 52.1431 144.178 52.9455 143.378 53.1769C142.839 53.2943 140.901 53.2155 137.462 51.961Z",
    fill: "url(#paint88_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.423 49.1942C136.696 49.1943 133.698 49.9984 132.539 50.4004C134.936 49.2906 135.838 48.2822 137.649 46.8887C139.098 45.7738 140.394 45.2454 140.849 45.0875L141.304 44.9947C143.333 45.0696 143.607 46.421 143.49 47.0874C143.27 47.7896 142.149 49.1941 139.423 49.1942Z",
    fill: "url(#paint89_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5369 97.0758C14.9944 98.2804 17.4494 97.9571 18.2448 97.6449C17.2809 98.3912 15.1856 100.462 14.5158 102.774C13.8459 105.087 11.8558 107.255 10.9985 108.102C10.2237 108.663 8.5198 108.783 8.05318 107.499C7.58656 106.214 8.66014 105.321 9.25526 105.035C9.7624 104.827 11.0002 104.219 11.8941 103.447C12.788 102.675 13.8164 101.491 14.2188 100.995C14.7766 100.349 16.3628 98.776 18.2448 97.6449C16.2236 98.5469 13.0838 98.7042 11.7665 98.6701C11.4054 98.6381 10.4171 98.5731 9.35279 98.5682C8.28849 98.5634 7.03803 99.0596 6.54584 99.3083C5.7973 99.5569 4.19144 99.7162 3.75628 98.3643C3.32112 97.0125 4.8067 96.1885 5.60388 95.9455C6.14094 95.8204 8.07943 95.8711 11.5369 97.0758Z",
    fill: "url(#paint90_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6162 99.8706C12.3421 99.8311 15.3291 98.9837 16.4818 98.5649C14.1014 99.7093 13.2141 100.731 11.423 102.15C9.99006 103.286 8.70217 103.833 8.2493 103.998L7.79607 104.097C5.76628 104.051 5.47257 102.704 5.57944 102.036C5.78924 101.331 6.89031 99.9101 9.6162 99.8706Z",
    fill: "url(#paint91_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.162 69.027C138.164 66.925 135.714 66.5663 134.864 66.6498C135.994 66.1947 138.575 64.7741 139.85 62.732C141.126 60.6899 143.631 59.1473 144.687 58.5659C145.586 58.2374 147.258 58.5864 147.357 59.9495C147.455 61.3126 146.179 61.8792 145.528 61.9921C144.983 62.0534 143.627 62.3008 142.556 62.7998C141.485 63.2988 140.173 64.1579 139.651 64.525C138.938 64.9938 136.983 66.0749 134.864 66.6498C137.054 66.3333 140.118 67.0384 141.376 67.4305C141.714 67.5598 142.648 67.8919 143.67 68.1869C144.693 68.4819 146.031 68.3456 146.573 68.2406C147.361 68.2055 148.949 68.4903 148.999 69.9096C149.049 71.3289 147.395 71.7164 146.562 71.7327C146.011 71.7067 144.16 71.1291 141.162 69.027Z",
    fill: "url(#paint92_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.772 66.862C141.139 66.1565 138.034 66.1571 136.811 66.2455C139.413 65.7938 140.545 65.0532 142.656 64.176C144.344 63.4742 145.732 63.2992 146.213 63.2644L146.676 63.2925C148.616 63.89 148.531 65.2663 148.246 65.8798C147.852 66.5012 146.405 67.5676 143.772 66.862Z",
    fill: "url(#paint93_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85119 80.0128C10.8791 82.0713 13.3341 82.3944 14.1832 82.2987C13.059 82.7701 10.4992 84.2279 9.25366 86.2882C8.00809 88.3486 5.52477 89.9273 4.47741 90.5239C3.58376 90.8653 1.90678 90.5405 1.78851 89.179C1.67025 87.8175 2.93845 87.2325 3.58733 87.1102C4.13091 87.041 5.48389 86.774 6.54718 86.2595C7.61047 85.7451 8.91038 84.8671 9.42742 84.4925C10.1333 84.0135 12.0726 82.9041 14.1832 82.2987C11.9975 82.6468 8.92393 81.9861 7.66037 81.6122C7.31982 81.4879 6.38202 81.1693 5.35523 80.8891C4.32844 80.609 2.99217 80.7647 2.45238 80.8775C1.665 80.9239 0.0726366 80.6621 0.00218811 79.2437C-0.0682604 77.8253 1.57995 77.4139 2.41286 77.3855C2.96402 77.4036 4.82331 77.9544 7.85119 80.0128Z",
    fill: "url(#paint94_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27258 82.2153C7.91582 82.8827 11.0203 82.8372 12.2422 82.7311C9.64668 83.2204 8.52531 83.9773 6.42778 84.8849C4.74975 85.6111 3.36414 85.8062 2.88413 85.8479L2.42062 85.8266C0.471779 85.2572 0.536793 83.8798 0.812906 83.2622C1.19811 82.6352 2.62934 81.548 5.27258 82.2153Z",
    fill: "url(#paint95_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.325 86.4722C137.973 83.6659 135.699 82.6853 134.856 82.5458C136.066 82.399 138.927 81.6946 140.687 80.0522C142.447 78.4097 145.267 77.5683 146.438 77.28C147.39 77.1953 148.915 77.9652 148.658 79.3073C148.4 80.6494 147.02 80.8663 146.363 80.807C145.821 80.7253 144.446 80.6132 143.283 80.8181C142.12 81.023 140.63 81.513 140.03 81.7325C139.22 82.0008 137.052 82.5391 134.856 82.5458C137.054 82.8071 139.831 84.2811 140.944 84.9855C141.238 85.198 142.053 85.7603 142.965 86.3099C143.876 86.8595 145.204 87.0743 145.755 87.1129C146.525 87.2831 147.985 87.9692 147.666 89.3531C147.347 90.7369 145.649 90.6831 144.84 90.4832C144.315 90.3155 142.676 89.2785 140.325 86.4722Z",
    fill: "url(#paint96_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.406 85.0566C141.045 83.6936 138.046 82.8904 136.842 82.6593C139.472 82.8965 140.757 82.4742 143.023 82.1731C144.835 81.9322 146.222 82.1224 146.695 82.2133L147.135 82.3602C148.855 83.4396 148.416 84.747 147.982 85.2658C147.441 85.764 145.767 86.4196 143.406 85.0566Z",
    fill: "url(#paint97_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71309 62.5803C11.105 65.3523 13.3928 66.2999 14.2377 66.4271C13.0298 66.5915 10.18 67.3371 8.44357 69.0049C6.70719 70.6726 3.89989 71.5548 2.73381 71.86C1.78224 71.9585 0.246459 71.2107 0.484607 69.865C0.722755 68.5193 2.09915 68.2825 2.75759 68.3323C3.30055 68.4061 4.67654 68.4984 5.83674 68.2767C6.99695 68.0549 8.4798 67.5434 9.0762 67.3153C9.88195 67.0353 12.0423 66.4657 14.2377 66.4271C12.0364 66.1977 9.23855 64.764 8.11481 64.0758C7.81804 63.8676 6.99466 63.3171 6.07537 62.7808C5.15607 62.2444 3.82505 62.0489 3.27445 62.0182C2.50189 61.8592 1.03153 61.1942 1.3306 59.8059C1.62966 58.4176 3.32818 58.4468 4.14006 58.635C4.66776 58.7951 6.32115 59.8083 8.71309 62.5803Z",
    fill: "url(#paint98_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.65229 64.0404C8.03274 65.3691 11.0433 66.1287 12.2509 66.3424C9.61723 66.1432 8.33816 66.5841 6.07718 66.918C4.2684 67.1851 2.8795 67.0149 2.40505 66.931L1.96285 66.7904C0.227781 65.736 0.647083 64.4224 1.07362 63.8973C1.60798 63.3914 3.27183 62.7117 5.65229 64.0404Z",
    fill: "url(#paint99_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.006 103.082C133.461 99.7631 131.518 98.2274 130.74 97.8745C131.947 98.0459 134.892 98.1059 137.018 96.975C139.143 95.8441 142.084 95.7611 143.29 95.7856C144.232 95.9504 145.506 97.0887 144.909 98.3184C144.313 99.5481 142.924 99.4006 142.304 99.1731C141.802 98.9539 140.504 98.4898 139.327 98.3867C138.15 98.2835 136.584 98.3712 135.948 98.428C135.096 98.4776 132.863 98.4363 130.74 97.8745C132.795 98.6957 135.096 100.838 135.989 101.807C136.218 102.088 136.86 102.842 137.598 103.609C138.336 104.376 139.564 104.927 140.085 105.107C140.785 105.47 142.018 106.511 141.352 107.765C140.685 109.019 139.059 108.528 138.329 108.126C137.865 107.828 136.551 106.402 135.006 103.082Z",
    fill: "url(#paint100_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.349 102.513C136.421 100.585 133.732 99.033 132.628 98.4979C135.108 99.408 136.459 99.3327 138.725 99.6282C140.538 99.8647 141.828 100.407 142.261 100.617L142.648 100.873C144.03 102.361 143.268 103.51 142.715 103.899C142.063 104.24 140.277 104.44 138.349 102.513Z",
    fill: "url(#paint101_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 45.9411C15.6555 49.2377 17.6201 50.7451 18.4032 51.0867C17.194 50.9328 14.2483 50.9155 12.1394 52.077C10.0305 53.2385 7.09056 53.364 5.88522 53.357C4.94058 53.2059 3.65067 52.0861 4.229 50.8479C4.80733 49.6097 6.19813 49.7371 6.82123 49.9556C7.32659 50.1675 8.63181 50.6128 9.80987 50.6989C10.9879 50.785 12.5527 50.6746 13.1878 50.6087C14.0385 50.5468 16.2727 50.5557 18.4032 51.0867C16.3363 50.2954 14.0049 48.1864 13.0976 47.2308C12.8648 46.9529 12.212 46.208 11.4628 45.452C10.7136 44.696 9.47858 44.1627 8.95469 43.9905C8.24959 43.637 7.00145 42.6141 7.64965 41.3505C8.29785 40.0869 9.93093 40.5547 10.6664 40.9466C11.1347 41.2379 12.4695 42.6445 14.0625 45.9411Z",
    fill: "url(#paint102_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7281 46.5592C12.6836 48.4588 15.3949 49.9717 16.5061 50.4907C14.0137 49.6166 12.6641 49.7115 10.3938 49.4487C8.57748 49.2386 7.27995 48.7147 6.8434 48.5108L6.45264 48.2606C5.04958 46.7931 5.7946 45.6328 6.34249 45.236C6.9896 44.8856 8.77268 44.6597 10.7281 46.5592Z",
    fill: "url(#paint103_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.563 117.75C124.929 114.144 123.45 112.158 122.79 111.616C123.912 112.094 126.741 112.914 129.087 112.372C131.432 111.83 134.295 112.511 135.453 112.846C136.32 113.249 137.256 114.678 136.362 115.712C135.468 116.745 134.164 116.243 133.624 115.863C133.196 115.522 132.062 114.737 130.952 114.333C129.842 113.929 128.307 113.608 127.677 113.498C126.842 113.326 124.695 112.708 122.79 111.616C124.563 112.941 126.231 115.606 126.843 116.773C126.991 117.104 127.416 117.998 127.93 118.93C128.445 119.862 129.488 120.712 129.945 121.02C130.527 121.553 131.449 122.877 130.48 123.916C129.512 124.955 128.068 124.059 127.468 123.482C127.097 123.074 126.196 121.357 125.563 117.75Z",
    fill: "url(#paint104_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.939 118.065C127.576 115.704 125.38 113.509 124.453 112.707C126.612 114.228 127.937 114.504 130.049 115.376C131.739 116.074 132.845 116.932 133.209 117.247L133.517 117.595C134.466 119.389 133.433 120.302 132.798 120.535C132.08 120.695 130.302 120.426 128.939 118.065Z",
    fill: "url(#paint105_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5297 31.2537C24.2152 34.8503 25.7227 36.8148 26.3908 37.3475C25.2625 36.8858 22.4217 36.1067 20.084 36.6828C17.7464 37.2589 14.8741 36.6193 13.7117 36.3005C12.8383 35.91 11.8822 34.4946 12.7613 33.4482C13.6404 32.4019 14.9508 32.885 15.4961 33.2573C15.9294 33.5927 17.0749 34.3606 18.1906 34.7487C19.3062 35.1368 20.8462 35.4352 21.4767 35.5359C22.3145 35.6963 24.4702 36.2831 26.3908 37.3475C24.5991 36.0481 22.8929 33.4076 22.2639 32.2497C22.1109 31.921 21.6731 31.0326 21.1452 30.1084C20.6172 29.1843 19.5623 28.3495 19.1008 28.0476C18.5112 27.5236 17.5703 26.2126 18.5235 25.1598C19.4767 24.107 20.933 24.9816 21.542 25.5505C21.919 25.953 22.8442 27.6571 23.5297 31.2537Z",
    fill: "url(#paint106_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.149 30.9878C21.5461 33.3287 23.7735 35.4918 24.7125 36.2807C22.5313 34.7914 21.2031 34.5337 19.0781 33.6923C17.3781 33.0192 16.2604 32.1774 15.8915 31.8675L15.5788 31.5246C14.6034 29.744 15.6233 28.816 16.2552 28.5746C16.971 28.4036 18.7518 28.6468 20.149 30.9878Z",
    fill: "url(#paint107_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.639 129.477C112.96 125.829 112.046 123.528 111.549 122.833C112.508 123.585 115.029 125.11 117.435 125.193C119.841 125.277 122.43 126.675 123.461 127.299C124.195 127.913 124.729 129.536 123.598 130.303C122.466 131.069 121.337 130.247 120.914 129.74C120.589 129.299 119.696 128.248 118.729 127.57C117.761 126.893 116.361 126.186 115.782 125.917C115.02 125.534 113.106 124.381 111.549 122.833C112.918 124.572 113.839 127.578 114.128 128.864C114.186 129.222 114.365 130.196 114.621 131.229C114.877 132.262 115.664 133.353 116.025 133.769C116.45 134.434 116.997 135.952 115.793 136.705C114.589 137.458 113.426 136.219 112.996 135.506C112.743 135.016 112.317 133.124 112.639 129.477Z",
    fill: "url(#paint108_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.819 130.655C115.113 128.021 113.56 125.333 112.872 124.318C114.564 126.345 115.772 126.956 117.587 128.345C119.039 129.456 119.885 130.571 120.155 130.97L120.362 131.385C120.815 133.364 119.581 133.978 118.907 134.038C118.172 134.008 116.525 133.288 115.819 130.655Z",
    fill: "url(#paint109_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4695 19.5191C36.2008 23.1705 37.1485 25.4582 37.6559 26.1457C36.6856 25.4078 34.1432 23.9199 31.7361 23.8713C29.329 23.8228 26.7202 22.4616 25.6798 21.8528C24.9373 21.2496 24.3801 19.6349 25.5001 18.8517C26.62 18.0686 27.7608 18.8743 28.1911 19.3751C28.5228 19.8113 29.4306 20.8495 30.4077 21.5131C31.3849 22.1767 32.7952 22.8635 33.3782 23.124C34.1459 23.4957 36.0763 24.6206 37.6559 26.1457C36.2616 24.4269 35.297 21.4347 34.989 20.1535C34.9264 19.7964 34.7334 18.825 34.4627 17.7957C34.1919 16.7664 33.3889 15.6869 33.0213 15.2759C32.5874 14.6172 32.018 13.1073 33.2111 12.3371C34.4043 11.5669 35.5846 12.7886 36.0257 13.4957C36.2856 13.9821 36.7383 15.8676 36.4695 19.5191Z",
    fill: "url(#paint110_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2728 18.3872C34.0165 21.01 35.6081 23.6758 36.311 24.6809C34.5895 22.6778 33.3733 22.0851 31.5385 20.7224C30.0706 19.6323 29.2088 18.5298 28.9327 18.135L28.7194 17.7229C28.2381 15.7505 29.4635 15.1181 30.1363 15.0484C30.872 15.0685 32.5291 15.7644 33.2728 18.3872Z",
    fill: "url(#paint111_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.115 137.462C98.3695 134.022 98.0818 131.563 97.7811 130.763C98.5133 131.737 100.553 133.862 102.856 134.566C105.159 135.269 107.297 137.29 108.132 138.16C108.682 138.942 108.778 140.648 107.486 141.096C106.195 141.544 105.318 140.458 105.04 139.858C104.84 139.348 104.25 138.102 103.491 137.197C102.732 136.292 101.562 135.246 101.072 134.837C100.435 134.27 98.8848 132.661 97.7811 130.763C98.6537 132.797 98.7656 135.939 98.7124 137.255C98.6752 137.616 98.5959 138.603 98.5756 139.667C98.5554 140.731 99.0335 141.989 99.275 142.485C99.5128 143.237 99.6488 144.845 98.2908 145.26C96.9328 145.676 96.1304 144.178 95.899 143.378C95.7816 142.839 95.8604 140.901 97.115 137.462Z",
    fill: "url(#paint112_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8817 139.423C99.8816 136.697 99.0775 133.698 98.6755 132.539C99.7853 134.936 100.794 135.838 102.187 137.649C103.302 139.098 103.83 140.394 103.988 140.849L104.081 141.304C104.006 143.333 102.655 143.607 101.989 143.49C101.286 143.27 99.8818 142.149 99.8817 139.423Z",
    fill: "url(#paint113_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0001 11.5369C50.7955 14.9944 51.1187 17.4494 51.431 18.2448C50.6847 17.2809 48.614 15.1856 46.3015 14.5158C43.989 13.8459 41.8214 11.8558 40.974 10.9985C40.4129 10.2237 40.2926 8.5198 41.5771 8.05318C42.8616 7.58656 43.7549 8.66014 44.041 9.25526C44.2486 9.76241 44.8566 11.0002 45.6288 11.8941C46.4009 12.788 47.5853 13.8164 48.0811 14.2188C48.7264 14.7766 50.2999 16.3628 51.431 18.2448C50.529 16.2236 50.3717 13.0838 50.4058 11.7665C50.4377 11.4054 50.5028 10.4171 50.5076 9.35279C50.5125 8.28849 50.0163 7.03803 49.7676 6.54584C49.519 5.7973 49.3597 4.19144 50.7115 3.75628C52.0634 3.32112 52.8873 4.8067 53.1303 5.60388C53.2555 6.14094 53.2047 8.07943 52.0001 11.5369Z",
    fill: "url(#paint114_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2052 9.6162C49.2448 12.3421 50.0922 15.3291 50.5109 16.4818C49.3666 14.1014 48.3452 13.2141 46.9256 11.423C45.7899 9.99006 45.2428 8.70217 45.0783 8.2493L44.9789 7.79607C45.0245 5.76628 46.3718 5.47257 47.0398 5.57944C47.7451 5.78924 49.1657 6.89031 49.2052 9.6162Z",
    fill: "url(#paint115_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0489 141.162C82.151 138.164 82.5096 135.714 82.4262 134.864C82.8812 135.994 84.3018 138.575 86.3439 139.85C88.386 141.126 89.9287 143.631 90.51 144.687C90.8385 145.586 90.4895 147.258 89.1264 147.357C87.7633 147.455 87.1967 146.179 87.0838 145.528C87.0225 144.983 86.7751 143.627 86.2761 142.556C85.7771 141.485 84.918 140.173 84.5509 139.651C84.0822 138.938 83.001 136.983 82.4262 134.864C82.7426 137.054 82.0375 140.118 81.6454 141.376C81.5162 141.714 81.184 142.648 80.889 143.67C80.5941 144.693 80.7303 146.031 80.8354 146.573C80.8704 147.361 80.5856 148.949 79.1663 148.999C77.747 149.049 77.3595 147.395 77.3432 146.562C77.3692 146.011 77.9469 144.16 80.0489 141.162Z",
    fill: "url(#paint116_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2139 143.772C82.9194 141.139 82.9189 138.034 82.8304 136.811C83.2821 139.413 84.0227 140.545 84.8999 142.656C85.6017 144.344 85.7767 145.732 85.8115 146.213L85.7835 146.676C85.186 148.616 83.8096 148.531 83.1961 148.246C82.5748 147.852 81.5084 146.405 82.2139 143.772Z",
    fill: "url(#paint117_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.063 7.85119C67.0046 10.8791 66.6814 13.3341 66.7772 14.1832C66.3058 13.059 64.848 10.4992 62.7876 9.25366C60.7273 8.00809 59.1486 5.52477 58.552 4.47741C58.2106 3.58376 58.5353 1.90678 59.8969 1.78851C61.2584 1.67025 61.8434 2.93845 61.9657 3.58733C62.0349 4.13091 62.3019 5.48389 62.8163 6.54718C63.3308 7.61047 64.2087 8.91038 64.5834 9.42742C65.0624 10.1333 66.1717 12.0726 66.7772 14.1832C66.429 11.9975 67.0898 8.92393 67.4636 7.66037C67.5879 7.31982 67.9066 6.38202 68.1867 5.35523C68.4669 4.32845 68.3112 2.99217 68.1984 2.45238C68.152 1.665 68.4137 0.0726366 69.8322 0.00218811C71.2506 -0.0682604 71.6619 1.57995 71.6903 2.41286C71.6722 2.96402 71.1215 4.82331 69.063 7.85119Z",
    fill: "url(#paint118_radial_113_11492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8605 5.27258C66.1932 7.91582 66.2386 11.0203 66.3448 12.2422C65.8555 9.64668 65.0986 8.52531 64.1909 6.42778C63.4648 4.74975 63.2697 3.36414 63.228 2.88413L63.2493 2.42062C63.8187 0.471779 65.1961 0.536793 65.8136 0.812906C66.4407 1.19811 67.5279 2.62934 66.8605 5.27258Z",
    fill: "url(#paint119_radial_113_11492)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_113_11492_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M80.7644 22.7854C82.1391 22.9981 84.7671 24.3202 84.281 27.9079C83.947 30.3726 82.768 31.4798 81.6633 32.5173C80.7579 33.3676 79.9024 34.171 79.6028 35.6364C79.5709 34.141 78.8733 33.1973 78.1351 32.1984C77.2343 30.9797 76.2729 29.679 76.3863 27.1944C76.5513 23.5776 79.3738 22.7481 80.7644 22.7854Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M67.6941 122.445C66.3453 122.104 63.8531 120.541 64.6739 117.015C65.2378 114.592 66.5156 113.601 67.7128 112.672C68.694 111.91 69.6211 111.19 70.0569 109.76C69.9483 111.251 70.5542 112.257 71.1955 113.32C71.9779 114.618 72.8129 116.003 72.4667 118.466C71.9629 122.052 69.075 122.613 67.6941 122.445Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M93.4872 26.1745C94.7601 26.7356 96.9564 28.6929 95.5582 32.0326C94.5977 34.3268 93.1723 35.0912 91.8367 35.8074C90.7421 36.3943 89.7078 36.949 89.0392 38.2869C89.3954 36.8342 88.9659 35.7421 88.5113 34.5862C87.9566 33.1758 87.3647 31.6706 88.1172 29.3C89.2127 25.8492 92.1537 25.7785 93.4872 26.1745Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M55.0685 119.055C53.854 118.377 51.8512 116.222 53.5567 113.029C54.7283 110.835 56.2192 110.207 57.6161 109.62C58.761 109.138 59.8428 108.683 60.6341 107.414C60.1431 108.827 60.4682 109.954 60.8122 111.148C61.232 112.604 61.6801 114.158 60.7083 116.448C59.2937 119.78 56.359 119.575 55.0685 119.055Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M104.899 32.7157C105.984 33.5872 107.598 36.0462 105.383 38.9102C103.862 40.8777 102.287 41.2471 100.812 41.5932C99.6026 41.8769 98.46 42.1449 97.4679 43.2642C98.1879 41.9532 98.0557 40.7871 97.9157 39.553C97.745 38.0471 97.5628 36.44 98.9033 34.3449C100.855 31.2952 103.714 31.9881 104.899 32.7157Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M43.7503 112.488C42.7527 111.519 41.3758 108.919 43.8498 106.276C45.5494 104.46 47.1518 104.24 48.6532 104.034C49.8837 103.865 51.0464 103.705 52.1392 102.684C51.2993 103.922 51.3215 105.095 51.3449 106.337C51.3735 107.852 51.4041 109.469 49.8728 111.429C47.6438 114.282 44.8624 113.324 43.7503 112.488Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M114.223 41.9635C115.045 43.0859 115.968 45.8791 113.087 48.0722C111.108 49.5788 109.492 49.5281 107.977 49.4806C106.735 49.4416 105.562 49.4048 104.314 50.2291C105.349 49.1492 105.523 47.9886 105.708 46.7603C105.932 45.2615 106.172 43.662 108.009 41.9853C110.684 39.5445 113.266 40.9538 114.223 41.9635Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M34.5108 103.191C33.7981 101.997 33.141 99.129 36.2149 97.2161C38.3265 95.9019 39.9312 96.1042 41.4348 96.2937C42.6671 96.4491 43.8315 96.5958 45.1514 95.8923C44.0198 96.8703 43.7375 98.0095 43.4387 99.215C43.0742 100.686 42.6852 102.256 40.6988 103.753C37.8074 105.932 35.3687 104.286 34.5108 103.191Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M120.822 53.2874C121.326 54.5843 121.495 57.5213 118.145 58.8941C115.843 59.8372 114.295 59.3698 112.844 58.9318C111.655 58.5729 110.531 58.2337 109.112 58.707C110.391 57.9317 110.86 56.8557 111.356 55.7169C111.961 54.3274 112.607 52.8445 114.815 51.7004C118.03 50.0349 120.159 52.0645 120.822 53.2874Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M27.9797 91.7979C27.6004 90.4595 27.708 87.5197 31.1722 86.4674C33.552 85.7445 35.0497 86.3553 36.453 86.9275C37.6031 87.3965 38.6898 87.8397 40.1468 87.5017C38.8006 88.1535 38.2331 89.1808 37.6325 90.268C36.8997 91.5945 36.1176 93.0102 33.8115 93.942C30.4546 95.2983 28.525 93.0777 27.9797 91.7979Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M124.248 65.9159C124.399 67.2989 123.802 70.1795 120.211 70.6385C117.743 70.9538 116.369 70.1015 115.081 69.303C114.025 68.6485 113.028 68.0301 111.535 68.12C112.971 67.7022 113.702 66.7841 114.476 65.8125C115.42 64.6269 116.427 63.3617 118.857 62.8281C122.393 62.0514 123.924 64.563 124.248 65.9159Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M24.602 79.0848C24.582 77.6938 25.4468 74.8819 29.0653 74.7621C31.5511 74.6798 32.8397 75.6574 34.0471 76.5734C35.0366 77.324 35.9716 78.0334 37.4665 78.084C35.9974 78.3652 35.1834 79.2106 34.3219 80.1053C33.2707 81.1969 32.1488 82.362 29.6801 82.6651C26.0866 83.1064 24.7974 80.4621 24.602 79.0848Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M124.267 78.9883C124.055 80.3631 122.732 82.9911 119.145 82.5049C116.68 82.171 115.573 80.9919 114.535 79.8872C113.685 78.9818 112.882 78.1264 111.416 77.8268C112.912 77.7949 113.855 77.0973 114.854 76.359C116.073 75.4583 117.374 74.4969 119.858 74.6102C123.475 74.7752 124.304 77.5977 124.267 78.9883Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M24.6078 65.9181C24.9485 64.5694 26.5116 62.0771 30.0378 62.898C32.4602 63.4619 33.4519 64.7396 34.3811 65.9369C35.1426 66.9181 35.8621 67.8452 37.2929 68.281C35.8012 68.1724 34.7961 68.7783 33.7324 69.4195C32.4344 70.2019 31.0492 71.0369 28.5862 70.6908C25.001 70.187 24.4401 67.2991 24.6078 65.9181Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M120.878 91.7112C120.317 92.9841 118.36 95.1804 115.02 93.7822C112.726 92.8217 111.961 91.3963 111.245 90.0607C110.658 88.9661 110.104 87.9318 108.766 87.2632C110.218 87.6194 111.311 87.1899 112.466 86.7353C113.877 86.1806 115.382 85.5887 117.753 86.3412C121.203 87.4367 121.274 90.3777 120.878 91.7112Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M27.9975 53.2926C28.6757 52.0781 30.8305 50.0753 34.0241 51.7808C36.2181 52.9524 36.8452 54.4433 37.4329 55.8403C37.9145 56.9851 38.3696 58.0669 39.6388 58.8582C38.226 58.3672 37.0983 58.6923 35.9049 59.0363C34.4487 59.4561 32.8946 59.9042 30.6051 58.9324C27.2724 57.5178 27.478 54.5831 27.9975 53.2926Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M114.337 103.123C113.465 104.208 111.006 105.822 108.142 103.608C106.175 102.086 105.806 100.511 105.459 99.0359C105.176 97.8266 104.908 96.6841 103.788 95.6919C105.099 96.412 106.266 96.2797 107.5 96.1398C109.006 95.9691 110.613 95.7868 112.708 97.1273C115.757 99.0786 115.065 101.938 114.337 103.123Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M34.5646 41.9745C35.534 40.9768 38.1338 39.6 40.7771 42.074C42.5931 43.7735 42.813 45.3759 43.0191 46.8774C43.188 48.1079 43.3476 49.2706 44.3688 50.3634C43.1312 49.5235 41.9578 49.5456 40.716 49.5691C39.2007 49.5977 37.5836 49.6282 35.6236 48.097C32.7706 45.868 33.7288 43.0866 34.5646 41.9745Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M105.089 112.447C103.967 113.269 101.174 114.192 98.9805 111.311C97.4738 109.332 97.5246 107.716 97.5721 106.201C97.6111 104.96 97.6479 103.787 96.8235 102.539C97.9035 103.573 99.0641 103.747 100.292 103.932C101.791 104.157 103.391 104.396 105.067 106.233C107.508 108.908 106.099 111.49 105.089 112.447Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M43.8615 32.735C45.0561 32.0222 47.9236 31.3652 49.8366 34.439C51.1508 36.5507 50.9485 38.1554 50.759 39.659C50.6036 40.8913 50.4568 42.0557 51.1604 43.3756C50.1824 42.244 49.0432 41.9617 47.8376 41.6629C46.3666 41.2984 44.7967 40.9093 43.2998 38.923C41.1209 36.0315 42.7664 33.5929 43.8615 32.735Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M93.7652 119.046C92.4684 119.55 89.5314 119.719 88.1585 116.369C87.2154 114.067 87.6829 112.519 88.1208 111.068C88.4798 109.879 88.819 108.755 88.3457 107.336C89.121 108.615 90.197 109.084 91.3358 109.58C92.7253 110.185 94.2082 110.831 95.3523 113.039C97.0178 116.254 94.9882 118.383 93.7652 119.046Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M55.2547 26.2038C56.5931 25.8246 59.533 25.9321 60.5853 29.3963C61.3081 31.7761 60.6974 33.2738 60.1252 34.6771C59.6562 35.8272 59.213 36.9139 59.551 38.3709C58.8992 37.0247 57.8719 36.4572 56.7847 35.8566C55.4582 35.1238 54.0424 34.3417 53.1107 32.0356C51.7544 28.6787 53.9749 26.7491 55.2547 26.2038Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M81.1368 122.472C79.7538 122.623 76.8732 122.026 76.4142 118.435C76.0989 115.968 76.9511 114.593 77.7497 113.305C78.4042 112.249 79.0226 111.252 78.9326 109.759C79.3505 111.195 80.2686 111.926 81.2402 112.7C82.4257 113.644 83.691 114.651 84.2246 117.081C85.0013 120.617 82.4897 122.149 81.1368 122.472Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M67.9679 22.826C69.3588 22.8061 72.1707 23.6708 72.2905 27.2894C72.3728 29.7752 71.3952 31.0638 70.4793 32.2712C69.7286 33.2607 69.0193 34.1957 68.9686 35.6905C68.6874 34.2215 67.8421 33.4074 66.9474 32.5459C65.8557 31.4947 64.6906 30.3728 64.3875 27.9042C63.9462 24.3107 66.5905 23.0215 67.9679 22.826Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M74.59 51.4374C76.5995 48.3882 77.7662 44.753 77.7662 40.85C77.7662 36.9471 76.5995 33.3118 74.59 30.2627C72.5806 33.3118 71.4138 36.9471 71.4138 40.85C71.4138 44.753 72.5806 48.3882 74.59 51.4374Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M74.59 114.961C76.5995 111.912 77.7662 108.277 77.7662 104.374C77.7662 100.471 76.5995 96.836 74.59 93.7868C72.5806 96.836 71.4138 100.471 71.4138 104.374C71.4138 108.277 72.5806 111.912 74.59 114.961Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M80.0705 52.1589C82.8006 49.7337 84.8685 46.5243 85.8786 42.7544C86.8888 38.9844 86.7027 35.1711 85.5509 31.7057C82.8207 34.1309 80.7528 37.3403 79.7427 41.1103C78.7325 44.8802 78.9186 48.6936 80.0705 52.1589Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M63.6292 113.518C66.3594 111.093 68.4273 107.884 69.4374 104.114C70.4476 100.344 70.2615 96.5306 69.1097 93.0653C66.3795 95.4905 64.3116 98.6998 63.3015 102.47C62.2913 106.24 62.4774 110.053 63.6292 113.518Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M85.1775 54.2742C88.4423 52.6383 91.2703 50.0735 93.2218 46.6934C95.1733 43.3134 95.9805 39.5818 95.7648 35.9365C92.5 37.5723 89.6719 40.1372 87.7204 43.5173C85.769 46.8973 84.9618 50.6289 85.1775 54.2742Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M53.4154 109.288C56.6802 107.652 59.5082 105.087 61.4597 101.707C63.4112 98.3269 64.2184 94.5953 64.0027 90.95C60.7379 92.5859 57.9099 95.1507 55.9584 98.5308C54.0069 101.911 53.1997 105.642 53.4154 109.288Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M89.5629 57.6393C93.1399 56.9041 96.5354 55.1586 99.2952 52.3988C102.055 49.639 103.8 46.2435 104.536 42.6665C100.959 43.4017 97.5632 45.1472 94.8034 47.907C92.0435 50.6668 90.2981 54.0623 89.5629 57.6393Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M44.6445 102.558C48.2215 101.822 51.617 100.077 54.3768 97.3172C57.1366 94.5574 58.8821 91.1619 59.6172 87.5849C56.0403 88.3201 52.6448 90.0655 49.8849 92.8254C47.1251 95.5852 45.3796 98.9807 44.6445 102.558Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M92.9279 62.0247C96.5733 62.2404 100.305 61.4332 103.685 59.4817C107.065 57.5303 109.63 54.7022 111.266 51.4374C107.62 51.2217 103.889 52.0289 100.509 53.9804C97.1286 55.9319 94.5638 58.7599 92.9279 62.0247Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M37.9144 93.7868C41.5598 94.0025 45.2913 93.1953 48.6714 91.2438C52.0515 89.2923 54.6163 86.4643 56.2522 83.1995C52.6068 82.9838 48.8753 83.791 45.4952 85.7425C42.1151 87.6939 39.5503 90.522 37.9144 93.7868Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M95.0433 67.1316C98.5086 68.2835 102.322 68.4696 106.092 67.4594C109.862 66.4493 113.071 64.3814 115.496 61.6513C112.031 60.4994 108.218 60.3133 104.448 61.3235C100.678 62.3336 97.4684 64.4015 95.0433 67.1316Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M33.6836 83.5729C37.149 84.7247 40.9623 84.9108 44.7323 83.9007C48.5023 82.8905 51.7116 80.8227 54.1368 78.0925C50.6715 76.9407 46.8581 76.7546 43.0881 77.7647C39.3182 78.7749 36.1088 80.8427 33.6836 83.5729Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M95.7648 72.6121C98.8139 74.6216 102.449 75.7883 106.352 75.7883C110.255 75.7883 113.89 74.6216 116.939 72.6121C113.89 70.6026 110.255 69.4359 106.352 69.4359C102.449 69.4359 98.8139 70.6026 95.7648 72.6121Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M32.2407 72.6121C35.2898 74.6216 38.925 75.7883 42.828 75.7883C46.731 75.7883 50.3662 74.6216 53.4153 72.6121C50.3662 70.6026 46.731 69.4359 42.828 69.4359C38.925 69.4359 35.2898 70.6026 32.2407 72.6121Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M95.0433 78.0925C97.4684 80.8227 100.678 82.8905 104.448 83.9007C108.218 84.9109 112.031 84.7247 115.496 83.5729C113.071 80.8427 109.862 78.7749 106.092 77.7647C102.322 76.7546 98.5086 76.9407 95.0433 78.0925Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M33.6837 61.6512C36.1088 64.3814 39.3182 66.4493 43.0882 67.4594C46.8582 68.4696 50.6715 68.2835 54.1368 67.1317C51.7117 64.4015 48.5023 62.3336 44.7323 61.3235C40.9623 60.3133 37.149 60.4994 33.6837 61.6512Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M92.9201 83.2153C94.557 86.475 97.1223 89.299 100.502 91.2485C103.882 93.198 107.613 94.0053 111.257 93.7916C109.62 90.5319 107.055 87.7078 103.675 85.7584C100.295 83.8089 96.5644 83.0016 92.9201 83.2153Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M37.9086 51.4862C39.5454 54.7459 42.1107 57.57 45.4907 59.5194C48.8706 61.4689 52.6015 62.2762 56.2457 62.0625C54.6088 58.8028 52.0435 55.9787 48.6636 54.0293C45.2836 52.0798 41.5528 51.2725 37.9086 51.4862Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M89.5579 87.6009C90.2953 91.1732 92.0423 94.565 94.8025 97.3228C97.5627 100.081 100.957 101.826 104.533 102.563C103.795 98.9906 102.048 95.5988 99.2882 92.841C96.528 90.0832 93.1333 88.3377 89.5579 87.6009Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M44.633 42.7149C45.3704 46.2872 47.1174 49.679 49.8776 52.4368C52.6378 55.1947 56.0326 56.9401 59.6079 57.6769C58.8705 54.1046 57.1235 50.7128 54.3633 47.955C51.6031 45.1972 48.2083 43.4517 44.633 42.7149Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M85.1752 90.9669C84.9629 94.6083 85.7725 98.3367 87.7249 101.715C89.6773 105.093 92.5046 107.658 95.7674 109.295C95.9797 105.653 95.1701 101.925 93.2177 98.5468C91.2653 95.1686 88.438 92.6039 85.1752 90.9669Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M53.3984 35.983C53.1861 39.6244 53.9957 43.3527 55.9481 46.731C57.9005 50.1092 60.7278 52.6739 63.9907 54.3109C64.2029 50.6695 63.3934 46.9411 61.441 43.5629C59.4886 40.1846 56.6613 37.62 53.3984 35.983Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M80.0706 93.0839C78.9231 96.5463 78.7402 100.357 79.7517 104.126C80.7632 107.894 82.8304 111.103 85.5583 113.529C86.7059 110.066 86.8888 106.256 85.8773 102.487C84.8658 98.7186 82.7986 95.5096 80.0706 93.0839Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M63.6075 31.749C62.46 35.2114 62.277 39.0223 63.2885 42.7908C64.3 46.5592 66.3672 49.7682 69.0952 52.1939C70.2427 48.7316 70.4257 44.9207 69.4142 41.1522C68.4027 37.3838 66.3355 34.1748 63.6075 31.749Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M71.3511 21.2657C73.4876 23.6918 74.3533 25.7492 74.5191 26.4746C75.687 23.7513 75.3772 24.9462 77.8379 20.8657C79.8064 17.6014 79.407 14.4633 78.9613 13.3022C78.595 12.4284 77.5359 10.3264 76.2296 8.90962C74.9232 7.49284 74.1912 5.12184 73.9885 4.11343C73.6945 6.4705 73.0919 8.02377 71.8444 9.57872C70.8463 10.8227 70.0862 12.8463 69.8308 13.7027C69.4474 15.2128 69.2145 18.8396 71.3511 21.2657Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M71.3511 137.091C73.4876 139.518 74.3533 141.575 74.5191 142.3C75.687 139.577 75.3772 140.772 77.8379 136.691C79.8064 133.427 79.407 130.289 78.9613 129.128C78.595 128.254 77.5359 126.152 76.2296 124.735C74.9232 123.319 74.1912 120.948 73.9885 119.939C73.6945 122.296 73.0919 123.849 71.8444 125.404C70.8463 126.648 70.0862 128.672 69.8308 129.528C69.4474 131.038 69.2145 134.665 71.3511 137.091Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M84.9077 22.2222C86.3435 25.1186 86.6473 27.3299 86.6196 28.0735C88.4526 25.7453 87.8441 26.8193 91.277 23.5148C94.0233 20.8711 94.4497 17.7366 94.3197 16.4997C94.1921 15.5608 93.7131 13.2564 92.818 11.5498C91.9228 9.84318 91.8294 7.36351 91.8946 6.337C91.0006 8.53765 90.0165 9.88203 88.409 11.0611C87.123 12.0044 85.865 13.7623 85.3967 14.5234C84.6355 15.8828 83.4719 19.3258 84.9077 22.2222Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M54.9299 134.101C56.3657 136.998 56.6694 139.209 56.6418 139.952C58.4748 137.624 57.8662 138.698 61.2991 135.394C64.0455 132.75 64.4719 129.616 64.3418 128.379C64.2142 127.44 63.7353 125.135 62.8401 123.429C61.945 121.722 61.8516 119.242 61.9168 118.216C61.0228 120.417 60.0387 121.761 58.4312 122.94C57.1452 123.883 55.8872 125.641 55.4189 126.402C54.6576 127.762 53.4941 131.205 54.9299 134.101Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M97.7549 26.6548C98.3921 29.8241 98.1132 32.0387 97.8941 32.7498C100.267 30.9753 99.4014 31.8552 103.573 29.5518C106.91 27.7091 108.133 24.7917 108.327 23.5633C108.447 22.6234 108.581 20.2735 108.158 18.3933C107.735 16.5132 108.286 14.0939 108.615 13.1192C107.182 15.0135 105.883 16.0574 104.026 16.7802C102.539 17.3585 100.869 18.7309 100.22 19.3449C99.1327 20.461 97.1176 23.4855 97.7549 26.6548Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M39.8422 126.963C40.4794 130.132 40.2005 132.347 39.9813 133.058C42.3544 131.283 41.4886 132.163 45.6598 129.86C48.9968 128.017 50.22 125.1 50.4145 123.871C50.5343 122.931 50.668 120.581 50.2451 118.701C49.8222 116.821 50.3737 114.402 50.7024 113.427C49.2692 115.321 47.9707 116.365 46.1129 117.088C44.6265 117.666 42.9564 119.039 42.3071 119.653C41.2199 120.769 39.2049 123.793 39.8422 126.963Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M109.017 34.2614C108.812 37.4877 107.97 39.5546 107.574 40.1848C110.325 39.0849 109.261 39.7108 113.887 38.5654C117.587 37.6492 119.523 35.1478 120.029 34.0116C120.388 33.1347 121.126 30.8995 121.204 28.974C121.282 27.0484 122.441 24.8543 123.01 23.9979C121.136 25.4567 119.611 26.1289 117.63 26.3463C116.044 26.5202 114.076 27.4136 113.29 27.8386C111.951 28.6353 109.222 31.0352 109.017 34.2614Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M27.116 116.163C26.9112 119.389 26.0686 121.456 25.6729 122.086C28.4244 120.986 27.3604 121.612 31.9856 120.467C35.6858 119.55 37.6224 117.049 38.1282 115.913C38.4872 115.036 39.2246 112.801 39.3027 110.875C39.3808 108.95 40.5397 106.755 41.1094 105.899C39.2349 107.358 37.7104 108.03 35.7288 108.247C34.1434 108.421 32.175 109.315 31.3889 109.74C30.0499 110.536 27.3207 112.936 27.116 116.163Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M117.927 44.5238C116.894 47.5871 115.545 49.3655 115 49.8718C117.942 49.5215 116.752 49.8507 121.516 49.9415C125.328 50.0141 127.846 48.0992 128.628 47.1326C129.202 46.3785 130.493 44.4103 131.067 42.5706C131.64 40.7309 133.328 38.9115 134.1 38.2317C131.911 39.1556 130.265 39.4104 128.295 39.1074C126.718 38.8651 124.586 39.2186 123.716 39.4257C122.217 39.8486 118.959 41.4604 117.927 44.5238Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M17.6187 102.437C16.5859 105.5 15.2371 107.278 14.6918 107.785C17.6342 107.434 16.4444 107.764 21.2085 107.854C25.0198 107.927 27.5378 106.012 28.3204 105.046C28.8941 104.291 30.1849 102.323 30.7587 100.484C31.3325 98.6438 33.0198 96.8244 33.7918 96.1447C31.6035 97.0686 29.957 97.3233 27.9866 97.0204C26.4103 96.778 24.2777 97.1315 23.4084 97.3386C21.9089 97.7616 18.6515 99.3733 17.6187 102.437Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M123.877 56.7424C122.086 59.4341 120.323 60.8028 119.665 61.1506C122.598 61.5739 121.364 61.5839 125.942 62.9046C129.605 63.9612 132.532 62.7632 133.538 62.0322C134.288 61.4522 136.044 59.8852 137.074 58.2567C138.105 56.6282 140.206 55.3074 141.127 54.8506C138.774 55.1767 137.118 54.9967 135.293 54.1941C133.833 53.552 131.682 53.3415 130.789 53.3165C129.231 53.3369 125.667 54.0507 123.877 56.7424Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M11.9977 86.7204C10.2072 89.4121 8.44407 90.7807 7.78629 91.1286C10.7191 91.5519 9.48469 91.5619 14.0629 92.8826C17.7255 93.9392 20.6534 92.7412 21.6595 92.0101C22.4088 91.4302 24.165 89.8632 25.1954 88.2347C26.2258 86.6061 28.3266 85.2854 29.2482 84.8286C26.8953 85.1547 25.239 84.9746 23.4142 84.172C21.9543 83.53 19.8028 83.3195 18.9096 83.2945C17.3516 83.3149 13.7882 84.0287 11.9977 86.7204Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M126.461 70.0847C124.035 72.2213 121.978 73.087 121.253 73.2527C123.976 74.4206 122.781 74.1108 126.861 76.5715C130.126 78.54 133.264 78.1406 134.425 77.6949C135.299 77.3286 137.401 76.2695 138.818 74.9632C140.234 73.6569 142.605 72.9249 143.614 72.7221C141.257 72.4281 139.703 71.8255 138.148 70.578C136.905 69.5799 134.881 68.8198 134.025 68.5644C132.514 68.181 128.888 67.9482 126.461 70.0847Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M10.6358 70.0848C8.20972 72.2214 6.15238 73.0871 5.42698 73.2528C8.15029 74.4207 6.95537 74.1109 11.0358 76.5716C14.3001 78.5401 17.4383 78.1407 18.5993 77.695C19.4732 77.3287 21.5752 76.2696 22.9919 74.9633C24.4087 73.657 26.7797 72.925 27.7881 72.7223C25.431 72.4282 23.8778 71.8256 22.3228 70.5781C21.0789 69.58 19.0552 68.8199 18.1989 68.5646C16.6887 68.1811 13.0619 67.9483 10.6358 70.0848Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M125.505 83.6414C122.609 85.0772 120.397 85.3809 119.654 85.3533C121.982 87.1863 120.908 86.5777 124.212 90.0106C126.856 92.757 129.991 93.1834 131.227 93.0533C132.166 92.9257 134.471 92.4468 136.177 91.5516C137.884 90.6565 140.364 90.5631 141.39 90.6283C139.19 89.7342 137.845 88.7502 136.666 87.1427C135.723 85.8567 133.965 84.5987 133.204 84.1304C131.844 83.3691 128.401 82.2056 125.505 83.6414Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M13.626 53.6636C10.7296 55.0994 8.51831 55.4031 7.77471 55.3755C10.103 57.2085 9.02894 56.5999 12.3335 60.0328C14.9771 62.7792 18.1117 63.2056 19.3485 63.0756C20.2874 62.948 22.5918 62.469 24.2984 61.5739C26.0051 60.6787 28.4847 60.5853 29.5112 60.6505C27.3106 59.7565 25.9662 58.7724 24.7871 57.1649C23.8439 55.8789 22.0859 54.6209 21.3248 54.1526C19.9654 53.3913 16.5224 52.2278 13.626 53.6636Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M121.072 96.4885C117.903 97.1258 115.689 96.8468 114.977 96.6277C116.752 99.0008 115.872 98.135 118.175 102.306C120.018 105.643 122.936 106.866 124.164 107.061C125.104 107.181 127.454 107.314 129.334 106.892C131.214 106.469 133.633 107.02 134.608 107.349C132.714 105.916 131.67 104.617 130.947 102.759C130.369 101.273 128.996 99.6028 128.382 98.9535C127.266 97.8663 124.242 95.8513 121.072 96.4885Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M20.7645 38.5758C17.5951 39.2131 15.3806 38.9341 14.6695 38.715C16.444 41.0881 15.564 40.2223 17.8675 44.3935C19.7102 47.7305 22.6276 48.9537 23.856 49.1482C24.7959 49.2679 27.1458 49.4017 29.0259 48.9788C30.906 48.5558 33.3254 49.1074 34.3001 49.4361C32.4058 48.0029 31.3619 46.7044 30.6391 44.8465C30.0608 43.3602 28.6883 41.6901 28.0744 41.0408C26.9583 39.9536 23.9338 37.9386 20.7645 38.5758Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M113.466 107.751C110.24 107.546 108.173 106.703 107.542 106.308C108.642 109.059 108.016 107.995 109.162 112.62C110.078 116.321 112.579 118.257 113.716 118.763C114.593 119.122 116.828 119.859 118.753 119.937C120.679 120.016 122.873 121.174 123.729 121.744C122.271 119.87 121.598 118.345 121.381 116.363C121.207 114.778 120.314 112.81 119.889 112.024C119.092 110.685 116.692 107.955 113.466 107.751Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M31.5646 25.8497C28.3383 25.645 26.2714 24.8023 25.6413 24.4066C26.7411 27.1581 26.1153 26.0941 27.2606 30.7194C28.1769 34.4196 30.6783 36.3562 31.8145 36.8619C32.6914 37.2209 34.9266 37.9583 36.8521 38.0364C38.7776 38.1145 40.9718 39.2734 41.8282 39.8432C40.3694 37.9686 39.6971 36.4441 39.4798 34.4625C39.3059 32.8771 38.4125 30.9087 37.9875 30.1226C37.1908 28.7836 34.7909 26.0545 31.5646 25.8497Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M103.203 116.66C100.14 115.628 98.3617 114.279 97.8554 113.733C98.2056 116.676 97.8765 115.486 97.7857 120.25C97.7131 124.061 99.628 126.579 100.595 127.362C101.349 127.936 103.317 129.227 105.157 129.8C106.996 130.374 108.816 132.061 109.495 132.833C108.572 130.645 108.317 128.999 108.62 127.028C108.862 125.452 108.509 123.319 108.302 122.45C107.879 120.95 106.267 117.693 103.203 116.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M45.2906 16.3525C42.2272 15.3197 40.4488 13.9709 39.9426 13.4255C40.2928 16.3679 39.9636 15.1782 39.8729 19.9423C39.8002 23.7535 41.7152 26.2716 42.6817 27.0542C43.4358 27.6279 45.404 28.9187 47.2437 29.4925C49.0834 30.0663 50.9029 31.7536 51.5826 32.5256C50.6587 30.3373 50.4039 28.6908 50.7069 26.7204C50.9492 25.1441 50.5957 23.0114 50.3887 22.1422C49.9657 20.6426 48.3539 17.3853 45.2906 16.3525Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M90.9848 122.61C88.2931 120.82 86.9244 119.057 86.5765 118.399C86.1533 121.332 86.1433 120.097 84.8225 124.676C83.766 128.338 84.964 131.266 85.695 132.272C86.275 133.021 87.842 134.778 89.4705 135.808C91.099 136.838 92.4197 138.939 92.8765 139.861C92.5505 137.508 92.7305 135.852 93.5331 134.027C94.1752 132.567 94.3857 130.415 94.4107 129.522C94.3902 127.964 93.6764 124.401 90.9848 122.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M61.0068 10.7315C58.3152 8.94101 56.9465 7.17783 56.5986 6.52005C56.1753 9.45285 56.1653 8.21846 54.8446 12.7967C53.788 16.4593 54.986 19.3872 55.7171 20.3933C56.297 21.1426 57.864 22.8988 59.4926 23.9292C61.1211 24.9596 62.4418 27.0603 62.8986 27.9819C62.5725 25.6291 62.7526 23.9728 63.5552 22.1479C64.1973 20.688 64.4078 18.5366 64.4327 17.6433C64.4123 16.0854 63.6985 12.5219 61.0068 10.7315Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M86.4721 8.75129C83.6658 11.1029 82.6852 13.3767 82.5457 14.2197C82.3989 13.0095 81.6946 10.1492 80.0521 8.38885C78.4096 6.62851 77.5682 3.80875 77.2799 2.63837C77.1951 1.68547 77.965 0.160676 79.3072 0.41827C80.6493 0.675865 80.8662 2.05555 80.8069 2.71319C80.7252 3.25503 80.613 4.62954 80.8179 5.79283C81.0229 6.95612 81.5129 8.44622 81.7324 9.04585C82.0007 9.85558 82.539 12.024 82.5457 14.2197C82.807 12.0219 84.281 9.2451 84.9854 8.13144C85.1979 7.83771 85.7602 7.02239 86.3098 6.11095C86.8594 5.19951 87.0742 3.87145 87.1128 3.32135C87.283 2.55117 87.9691 1.09059 89.353 1.40972C90.7368 1.72884 90.683 3.42676 90.4832 4.23583C90.3154 4.76116 89.2784 6.39971 86.4721 8.75129Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M85.0565 5.66968C83.6934 8.03066 82.8903 11.0299 82.6592 12.2343C82.8964 9.60378 82.4741 8.31848 82.173 6.0529C81.9321 4.24044 82.1223 2.85415 82.2132 2.38097L82.3601 1.94085C83.4394 0.221213 84.7469 0.659479 85.2657 1.09357C85.7639 1.6352 86.4195 3.3087 85.0565 5.66968Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M62.5803 140.363C65.3523 137.971 66.2998 135.683 66.4271 134.838C66.5914 136.046 67.3371 138.896 69.0048 140.632C70.6726 142.369 71.5548 145.176 71.86 146.342C71.9585 147.294 71.2107 148.83 69.865 148.591C68.5193 148.353 68.2824 146.977 68.3322 146.318C68.4061 145.775 68.4983 144.399 68.2766 143.239C68.0549 142.079 67.5433 140.596 67.3152 140C67.0352 139.194 66.4656 137.034 66.4271 134.838C66.1977 137.04 64.7639 139.837 64.0758 140.961C63.8676 141.258 63.3171 142.081 62.7807 143.001C62.2444 143.92 62.0489 145.251 62.0181 145.802C61.8592 146.574 61.1942 148.044 59.8059 147.745C58.4175 147.446 58.4468 145.748 58.6349 144.936C58.7951 144.408 59.8083 142.755 62.5803 140.363Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M64.0403 143.424C65.369 141.043 66.1287 138.033 66.3424 136.825C66.1432 139.459 66.5841 140.738 66.9179 142.999C67.185 144.808 67.0149 146.196 66.9309 146.671L66.7904 147.113C65.736 148.848 64.4223 148.429 63.8973 148.002C63.3913 147.468 62.7116 145.804 64.0403 143.424Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M103.082 14.07C99.763 15.6152 98.2274 17.5577 97.8745 18.3359C98.0458 17.129 98.1058 14.1838 96.9749 12.0583C95.8441 9.93288 95.7611 6.9914 95.7855 5.78629C95.9503 4.84394 97.0886 3.57036 98.3184 4.16655C99.5481 4.76274 99.4005 6.15154 99.173 6.77142C98.9539 7.27366 98.4898 8.5723 98.3866 9.74899C98.2835 10.9257 98.3712 12.4918 98.4279 13.1278C98.4775 13.9794 98.4362 16.2132 97.8745 18.3359C98.6957 16.2806 100.838 13.9799 101.807 13.0865C102.088 12.8578 102.842 12.2158 103.609 11.4777C104.376 10.7395 104.927 9.5123 105.107 8.99096C105.47 8.29105 106.511 7.05784 107.765 7.72426C109.019 8.39067 108.528 10.0168 108.125 10.7466C107.827 11.2106 106.402 12.5249 103.082 14.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M102.513 10.727C100.585 12.6548 99.0329 15.344 98.4979 16.4476C99.4079 13.968 99.3326 12.6172 99.6282 10.3509C99.8646 8.53786 100.407 7.24805 100.617 6.81449L100.873 6.42739C102.361 5.04571 103.51 5.80744 103.899 6.36102C104.24 7.01313 104.44 8.79929 102.513 10.727Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M45.941 135.013C49.2376 133.42 50.745 131.456 51.0866 130.673C50.9327 131.882 50.9154 134.828 52.0769 136.937C53.2384 139.045 53.3639 141.985 53.3569 143.191C53.2058 144.135 52.086 145.425 50.8478 144.847C49.6096 144.269 49.737 142.878 49.9555 142.255C50.1674 141.749 50.6127 140.444 50.6988 139.266C50.7849 138.088 50.6745 136.523 50.6086 135.888C50.5467 135.037 50.5556 132.803 51.0866 130.673C50.2953 132.74 48.1863 135.071 47.2307 135.978C46.9528 136.211 46.2079 136.864 45.4519 137.613C44.6959 138.362 44.1626 139.597 43.9904 140.121C43.6369 140.826 42.614 142.074 41.3504 141.426C40.0868 140.778 40.5546 139.145 40.9465 138.409C41.2378 137.941 42.6444 136.606 45.941 135.013Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M46.5591 138.348C48.4587 136.392 49.9716 133.681 50.4906 132.57C49.6165 135.062 49.7114 136.412 49.4486 138.682C49.2385 140.498 48.7146 141.796 48.5107 142.233L48.2605 142.623C46.793 144.026 45.6327 143.281 45.2359 142.733C44.8855 142.086 44.6596 140.303 46.5591 138.348Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M117.75 23.5131C114.144 24.1465 112.158 25.6254 111.616 26.2857C112.094 25.1643 112.914 22.335 112.372 19.9892C111.829 17.6435 112.511 14.7808 112.846 13.6231C113.249 12.7555 114.678 11.8199 115.712 12.7141C116.745 13.6082 116.243 14.9115 115.863 15.4514C115.522 15.8798 114.737 17.0141 114.333 18.124C113.929 19.2339 113.608 20.7694 113.498 21.3984C113.326 22.2338 112.708 24.3808 111.616 26.2857C112.941 24.513 115.606 22.8453 116.773 22.233C117.104 22.0848 117.998 21.6599 118.93 21.1454C119.862 20.6309 120.712 19.5881 121.02 19.131C121.553 18.5491 122.877 17.6273 123.916 18.5956C124.955 19.5639 124.059 21.0074 123.482 21.6082C123.074 21.9792 121.356 22.8798 117.75 23.5131Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M118.065 20.1366C115.704 21.4997 113.509 23.6956 112.707 24.6231C114.228 22.4636 114.504 21.1393 115.376 19.0267C116.074 17.3366 116.932 16.2312 117.247 15.8668L117.594 15.5591C119.389 14.6095 120.302 15.6428 120.534 16.2782C120.695 16.9963 120.426 18.7734 118.065 20.1366Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M31.2536 125.546C34.8502 124.861 36.8147 123.353 37.3474 122.685C36.8857 123.813 36.1066 126.654 36.6827 128.992C37.2588 131.329 36.6192 134.202 36.3004 135.364C35.9099 136.238 34.4945 137.194 33.4481 136.315C32.4018 135.435 32.8848 134.125 33.2572 133.58C33.5926 133.146 34.3605 132.001 34.7486 130.885C35.1367 129.77 35.4351 128.23 35.5358 127.599C35.6962 126.761 36.283 124.606 37.3474 122.685C36.048 124.477 33.4075 126.183 32.2496 126.812C31.9209 126.965 31.0325 127.403 30.1083 127.931C29.1842 128.459 28.3494 129.514 28.0475 129.975C27.5235 130.565 26.2125 131.506 25.1597 130.552C24.1069 129.599 24.9815 128.143 25.5504 127.534C25.9529 127.157 27.657 126.232 31.2536 125.546Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M30.9877 128.927C33.3286 127.53 35.4917 125.302 36.2806 124.363C34.7913 126.545 34.5336 127.873 33.6922 129.998C33.0191 131.698 32.1773 132.815 31.8674 133.184L31.5245 133.497C29.7439 134.473 28.8159 133.453 28.5745 132.821C28.4035 132.105 28.6467 130.324 30.9877 128.927Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M129.477 36.437C125.829 36.1155 123.528 37.0299 122.833 37.5274C123.585 36.5678 125.11 34.0472 125.193 31.6411C125.277 29.235 126.675 26.6461 127.299 25.6146C127.913 24.8809 129.536 24.3472 130.303 25.4783C131.069 26.6095 130.247 27.7385 129.74 28.1615C129.299 28.4869 128.248 29.3795 127.57 30.347C126.893 31.3145 126.186 32.7146 125.917 33.2938C125.534 34.0561 124.381 35.97 122.833 37.5274C124.572 36.158 127.578 35.2369 128.864 34.9475C129.222 34.89 130.196 34.7111 131.229 34.4553C132.262 34.1994 133.353 33.4122 133.769 33.0505C134.434 32.6262 135.952 32.0787 136.705 33.2829C137.458 34.487 136.219 35.6496 135.506 36.0804C135.016 36.3332 133.124 36.7586 129.477 36.437Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M130.655 33.257C128.021 33.9627 125.333 35.5155 124.318 36.2038C126.345 34.5115 126.956 33.304 128.345 31.489C129.456 30.0371 130.571 29.1914 130.97 28.921L131.385 28.7137C133.364 28.2609 133.978 29.4954 134.038 30.1692C134.008 30.9044 133.288 32.5513 130.655 33.257Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M19.519 112.606C23.1705 112.875 25.4582 111.927 26.1456 111.42C25.4077 112.39 23.9198 114.933 23.8713 117.34C23.8228 119.747 22.4615 122.356 21.8528 123.396C21.2496 124.139 19.6348 124.696 18.8517 123.576C18.0685 122.456 18.8743 121.315 19.3751 120.885C19.8112 120.553 20.8494 119.645 21.5131 118.668C22.1767 117.691 22.8635 116.281 23.1239 115.698C23.4957 114.93 24.6205 113 26.1456 111.42C24.4268 112.814 21.4347 113.779 20.1535 114.087C19.7964 114.149 18.8249 114.342 17.7956 114.613C16.7663 114.884 15.6869 115.687 15.2758 116.055C14.6172 116.488 13.1072 117.058 12.337 115.865C11.5668 114.672 12.7885 113.491 13.4956 113.05C13.982 112.79 15.8676 112.338 19.519 112.606Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M18.3871 115.803C21.0099 115.059 23.6758 113.468 24.6809 112.765C22.6777 114.486 22.085 115.703 20.7224 117.537C19.6322 119.005 18.5298 119.867 18.1349 120.143L17.7229 120.356C15.7504 120.838 15.118 119.612 15.0484 118.94C15.0685 118.204 15.7644 116.547 18.3871 115.803Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M137.462 51.961C134.022 50.7064 131.563 50.9941 130.763 51.2948C131.737 50.5626 133.862 48.5224 134.566 46.2199C135.269 43.9173 137.29 41.7787 138.16 40.9438C138.942 40.394 140.648 40.2984 141.096 41.5895C141.544 42.8806 140.457 43.7583 139.858 44.0357C139.348 44.2359 138.102 44.826 137.197 45.5851C136.292 46.3442 135.246 47.5137 134.837 48.0035C134.27 48.6408 132.661 50.1911 130.763 51.2948C132.797 50.4222 135.939 50.3104 137.255 50.3635C137.616 50.4007 138.603 50.48 139.667 50.5003C140.731 50.5205 141.989 50.0425 142.485 49.8009C143.237 49.5631 144.845 49.4271 145.26 50.7851C145.676 52.1431 144.178 52.9455 143.378 53.1769C142.839 53.2943 140.901 53.2155 137.462 51.961Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M139.423 49.1942C136.696 49.1943 133.698 49.9984 132.539 50.4004C134.936 49.2906 135.838 48.2822 137.649 46.8887C139.098 45.7738 140.394 45.2454 140.849 45.0875L141.304 44.9947C143.333 45.0696 143.607 46.421 143.49 47.0874C143.27 47.7896 142.149 49.1941 139.423 49.1942Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M11.5369 97.0758C14.9944 98.2804 17.4494 97.9571 18.2448 97.6449C17.2809 98.3912 15.1856 100.462 14.5158 102.774C13.8459 105.087 11.8558 107.255 10.9985 108.102C10.2237 108.663 8.5198 108.783 8.05318 107.499C7.58656 106.214 8.66014 105.321 9.25526 105.035C9.7624 104.827 11.0002 104.219 11.8941 103.447C12.788 102.675 13.8164 101.491 14.2188 100.995C14.7766 100.349 16.3628 98.776 18.2448 97.6449C16.2236 98.5469 13.0838 98.7042 11.7665 98.6701C11.4054 98.6381 10.4171 98.5731 9.35279 98.5682C8.28849 98.5634 7.03803 99.0596 6.54584 99.3083C5.7973 99.5569 4.19144 99.7162 3.75628 98.3643C3.32112 97.0125 4.8067 96.1885 5.60388 95.9455C6.14094 95.8204 8.07943 95.8711 11.5369 97.0758Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M9.6162 99.8706C12.3421 99.8311 15.3291 98.9837 16.4818 98.5649C14.1014 99.7093 13.2141 100.731 11.423 102.15C9.99006 103.286 8.70217 103.833 8.2493 103.998L7.79607 104.097C5.76628 104.051 5.47257 102.704 5.57944 102.036C5.78924 101.331 6.89031 99.9101 9.6162 99.8706Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M141.162 69.027C138.164 66.925 135.714 66.5663 134.864 66.6498C135.994 66.1947 138.575 64.7741 139.85 62.732C141.126 60.6899 143.631 59.1473 144.687 58.5659C145.586 58.2374 147.258 58.5864 147.357 59.9495C147.455 61.3126 146.179 61.8792 145.528 61.9921C144.983 62.0534 143.627 62.3008 142.556 62.7998C141.485 63.2988 140.173 64.1579 139.651 64.525C138.938 64.9938 136.983 66.0749 134.864 66.6498C137.054 66.3333 140.118 67.0384 141.376 67.4305C141.714 67.5598 142.648 67.8919 143.67 68.1869C144.693 68.4819 146.031 68.3456 146.573 68.2406C147.361 68.2055 148.949 68.4903 148.999 69.9096C149.049 71.3289 147.395 71.7164 146.562 71.7327C146.011 71.7067 144.16 71.1291 141.162 69.027Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M143.772 66.862C141.139 66.1565 138.034 66.1571 136.811 66.2455C139.413 65.7938 140.545 65.0532 142.656 64.176C144.344 63.4742 145.732 63.2992 146.213 63.2644L146.676 63.2925C148.616 63.89 148.531 65.2663 148.246 65.8798C147.852 66.5012 146.405 67.5676 143.772 66.862Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M7.85119 80.0128C10.8791 82.0713 13.3341 82.3944 14.1832 82.2987C13.059 82.7701 10.4992 84.2279 9.25366 86.2882C8.00809 88.3486 5.52477 89.9273 4.47741 90.5239C3.58376 90.8653 1.90678 90.5405 1.78851 89.179C1.67025 87.8175 2.93845 87.2325 3.58733 87.1102C4.13091 87.041 5.48389 86.774 6.54718 86.2595C7.61047 85.7451 8.91038 84.8671 9.42742 84.4925C10.1333 84.0135 12.0726 82.9041 14.1832 82.2987C11.9975 82.6468 8.92393 81.9861 7.66037 81.6122C7.31982 81.4879 6.38202 81.1693 5.35523 80.8891C4.32844 80.609 2.99217 80.7647 2.45238 80.8775C1.665 80.9239 0.0726366 80.6621 0.00218811 79.2437C-0.0682604 77.8253 1.57995 77.4139 2.41286 77.3855C2.96402 77.4036 4.82331 77.9544 7.85119 80.0128Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M5.27258 82.2153C7.91582 82.8827 11.0203 82.8372 12.2422 82.7311C9.64668 83.2204 8.52531 83.9773 6.42778 84.8849C4.74975 85.6111 3.36414 85.8062 2.88413 85.8479L2.42062 85.8266C0.471779 85.2572 0.536793 83.8798 0.812906 83.2622C1.19811 82.6352 2.62934 81.548 5.27258 82.2153Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M140.325 86.4722C137.973 83.6659 135.699 82.6853 134.856 82.5458C136.066 82.399 138.927 81.6946 140.687 80.0522C142.447 78.4097 145.267 77.5683 146.438 77.28C147.39 77.1953 148.915 77.9652 148.658 79.3073C148.4 80.6494 147.02 80.8663 146.363 80.807C145.821 80.7253 144.446 80.6132 143.283 80.8181C142.12 81.023 140.63 81.513 140.03 81.7325C139.22 82.0008 137.052 82.5391 134.856 82.5458C137.054 82.8071 139.831 84.2811 140.944 84.9855C141.238 85.198 142.053 85.7603 142.965 86.3099C143.876 86.8595 145.204 87.0743 145.755 87.1129C146.525 87.2831 147.985 87.9692 147.666 89.3531C147.347 90.7369 145.649 90.6831 144.84 90.4832C144.315 90.3155 142.676 89.2785 140.325 86.4722Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M143.406 85.0566C141.045 83.6936 138.046 82.8904 136.842 82.6593C139.472 82.8965 140.757 82.4742 143.023 82.1731C144.835 81.9322 146.222 82.1224 146.695 82.2133L147.135 82.3602C148.855 83.4396 148.416 84.747 147.982 85.2658C147.441 85.764 145.767 86.4196 143.406 85.0566Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M8.71309 62.5803C11.105 65.3523 13.3928 66.2999 14.2377 66.4271C13.0298 66.5915 10.18 67.3371 8.44357 69.0049C6.70719 70.6726 3.89989 71.5548 2.73381 71.86C1.78224 71.9585 0.246459 71.2107 0.484607 69.865C0.722755 68.5193 2.09915 68.2825 2.75759 68.3323C3.30055 68.4061 4.67654 68.4984 5.83674 68.2767C6.99695 68.0549 8.4798 67.5434 9.0762 67.3153C9.88195 67.0353 12.0423 66.4657 14.2377 66.4271C12.0364 66.1977 9.23855 64.764 8.11481 64.0758C7.81804 63.8676 6.99466 63.3171 6.07537 62.7808C5.15607 62.2444 3.82505 62.0489 3.27445 62.0182C2.50189 61.8592 1.03153 61.1942 1.3306 59.8059C1.62966 58.4176 3.32818 58.4468 4.14006 58.635C4.66776 58.7951 6.32115 59.8083 8.71309 62.5803Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M5.65229 64.0404C8.03274 65.3691 11.0433 66.1287 12.2509 66.3424C9.61723 66.1432 8.33816 66.5841 6.07718 66.918C4.2684 67.1851 2.8795 67.0149 2.40505 66.931L1.96285 66.7904C0.227781 65.736 0.647083 64.4224 1.07362 63.8973C1.60798 63.3914 3.27183 62.7117 5.65229 64.0404Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M135.006 103.082C133.461 99.7631 131.518 98.2274 130.74 97.8745C131.947 98.0459 134.892 98.1059 137.018 96.975C139.143 95.8441 142.084 95.7611 143.29 95.7856C144.232 95.9504 145.506 97.0887 144.909 98.3184C144.313 99.5481 142.924 99.4006 142.304 99.1731C141.802 98.9539 140.504 98.4898 139.327 98.3867C138.15 98.2835 136.584 98.3712 135.948 98.428C135.096 98.4776 132.863 98.4363 130.74 97.8745C132.795 98.6957 135.096 100.838 135.989 101.807C136.218 102.088 136.86 102.842 137.598 103.609C138.336 104.376 139.564 104.927 140.085 105.107C140.785 105.47 142.018 106.511 141.352 107.765C140.685 109.019 139.059 108.528 138.329 108.126C137.865 107.828 136.551 106.402 135.006 103.082Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M138.349 102.513C136.421 100.585 133.732 99.033 132.628 98.4979C135.108 99.408 136.459 99.3327 138.725 99.6282C140.538 99.8647 141.828 100.407 142.261 100.617L142.648 100.873C144.03 102.361 143.268 103.51 142.715 103.899C142.063 104.24 140.277 104.44 138.349 102.513Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M14.0625 45.9411C15.6555 49.2377 17.6201 50.7451 18.4032 51.0867C17.194 50.9328 14.2483 50.9155 12.1394 52.077C10.0305 53.2385 7.09056 53.364 5.88522 53.357C4.94058 53.2059 3.65067 52.0861 4.229 50.8479C4.80733 49.6097 6.19813 49.7371 6.82123 49.9556C7.32659 50.1675 8.63181 50.6128 9.80987 50.6989C10.9879 50.785 12.5527 50.6746 13.1878 50.6087C14.0385 50.5468 16.2727 50.5557 18.4032 51.0867C16.3363 50.2954 14.0049 48.1864 13.0976 47.2308C12.8648 46.9529 12.212 46.208 11.4628 45.452C10.7136 44.696 9.47858 44.1627 8.95469 43.9905C8.24959 43.637 7.00145 42.6141 7.64965 41.3505C8.29785 40.0869 9.93093 40.5547 10.6664 40.9466C11.1347 41.2379 12.4695 42.6445 14.0625 45.9411Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M10.7281 46.5592C12.6836 48.4588 15.3949 49.9717 16.5061 50.4907C14.0137 49.6166 12.6641 49.7115 10.3938 49.4487C8.57748 49.2386 7.27995 48.7147 6.8434 48.5108L6.45264 48.2606C5.04958 46.7931 5.7946 45.6328 6.34249 45.236C6.9896 44.8856 8.77268 44.6597 10.7281 46.5592Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M125.563 117.75C124.929 114.144 123.45 112.158 122.79 111.616C123.912 112.094 126.741 112.914 129.087 112.372C131.432 111.83 134.295 112.511 135.453 112.846C136.32 113.249 137.256 114.678 136.362 115.712C135.468 116.745 134.164 116.243 133.624 115.863C133.196 115.522 132.062 114.737 130.952 114.333C129.842 113.929 128.307 113.608 127.677 113.498C126.842 113.326 124.695 112.708 122.79 111.616C124.563 112.941 126.231 115.606 126.843 116.773C126.991 117.104 127.416 117.998 127.93 118.93C128.445 119.862 129.488 120.712 129.945 121.02C130.527 121.553 131.449 122.877 130.48 123.916C129.512 124.955 128.068 124.059 127.468 123.482C127.097 123.074 126.196 121.357 125.563 117.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M128.939 118.065C127.576 115.704 125.38 113.509 124.453 112.707C126.612 114.228 127.937 114.504 130.049 115.376C131.739 116.074 132.845 116.932 133.209 117.247L133.517 117.595C134.466 119.389 133.433 120.302 132.798 120.535C132.08 120.695 130.302 120.426 128.939 118.065Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M23.5297 31.2537C24.2152 34.8503 25.7227 36.8148 26.3908 37.3475C25.2625 36.8858 22.4217 36.1067 20.084 36.6828C17.7464 37.2589 14.8741 36.6193 13.7117 36.3005C12.8383 35.91 11.8822 34.4946 12.7613 33.4482C13.6404 32.4019 14.9508 32.885 15.4961 33.2573C15.9294 33.5927 17.0749 34.3606 18.1906 34.7487C19.3062 35.1368 20.8462 35.4352 21.4767 35.5359C22.3145 35.6963 24.4702 36.2831 26.3908 37.3475C24.5991 36.0481 22.8929 33.4076 22.2639 32.2497C22.1109 31.921 21.6731 31.0326 21.1452 30.1084C20.6172 29.1843 19.5623 28.3495 19.1008 28.0476C18.5112 27.5236 17.5703 26.2126 18.5235 25.1598C19.4767 24.107 20.933 24.9816 21.542 25.5505C21.919 25.953 22.8442 27.6571 23.5297 31.2537Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M20.149 30.9878C21.5461 33.3287 23.7735 35.4918 24.7125 36.2807C22.5313 34.7914 21.2031 34.5337 19.0781 33.6923C17.3781 33.0192 16.2604 32.1774 15.8915 31.8675L15.5788 31.5246C14.6034 29.744 15.6233 28.816 16.2552 28.5746C16.971 28.4036 18.7518 28.6468 20.149 30.9878Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M112.639 129.477C112.96 125.829 112.046 123.528 111.549 122.833C112.508 123.585 115.029 125.11 117.435 125.193C119.841 125.277 122.43 126.675 123.461 127.299C124.195 127.913 124.729 129.536 123.598 130.303C122.466 131.069 121.337 130.247 120.914 129.74C120.589 129.299 119.696 128.248 118.729 127.57C117.761 126.893 116.361 126.186 115.782 125.917C115.02 125.534 113.106 124.381 111.549 122.833C112.918 124.572 113.839 127.578 114.128 128.864C114.186 129.222 114.365 130.196 114.621 131.229C114.877 132.262 115.664 133.353 116.025 133.769C116.45 134.434 116.997 135.952 115.793 136.705C114.589 137.458 113.426 136.219 112.996 135.506C112.743 135.016 112.317 133.124 112.639 129.477Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M115.819 130.655C115.113 128.021 113.56 125.333 112.872 124.318C114.564 126.345 115.772 126.956 117.587 128.345C119.039 129.456 119.885 130.571 120.155 130.97L120.362 131.385C120.815 133.364 119.581 133.978 118.907 134.038C118.172 134.008 116.525 133.288 115.819 130.655Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M36.4695 19.5191C36.2008 23.1705 37.1485 25.4582 37.6559 26.1457C36.6856 25.4078 34.1432 23.9199 31.7361 23.8713C29.329 23.8228 26.7202 22.4616 25.6798 21.8528C24.9373 21.2496 24.3801 19.6349 25.5001 18.8517C26.62 18.0686 27.7608 18.8743 28.1911 19.3751C28.5228 19.8113 29.4306 20.8495 30.4077 21.5131C31.3849 22.1767 32.7952 22.8635 33.3782 23.124C34.1459 23.4957 36.0763 24.6206 37.6559 26.1457C36.2616 24.4269 35.297 21.4347 34.989 20.1535C34.9264 19.7964 34.7334 18.825 34.4627 17.7957C34.1919 16.7664 33.3889 15.6869 33.0213 15.2759C32.5874 14.6172 32.018 13.1073 33.2111 12.3371C34.4043 11.5669 35.5846 12.7886 36.0257 13.4957C36.2856 13.9821 36.7383 15.8676 36.4695 19.5191Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M33.2728 18.3872C34.0165 21.01 35.6081 23.6758 36.311 24.6809C34.5895 22.6778 33.3733 22.0851 31.5385 20.7224C30.0706 19.6323 29.2088 18.5298 28.9327 18.135L28.7194 17.7229C28.2381 15.7505 29.4635 15.1181 30.1363 15.0484C30.872 15.0685 32.5291 15.7644 33.2728 18.3872Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M97.115 137.462C98.3695 134.022 98.0818 131.563 97.7811 130.763C98.5133 131.737 100.553 133.862 102.856 134.566C105.159 135.269 107.297 137.29 108.132 138.16C108.682 138.942 108.778 140.648 107.486 141.096C106.195 141.544 105.318 140.458 105.04 139.858C104.84 139.348 104.25 138.102 103.491 137.197C102.732 136.292 101.562 135.246 101.072 134.837C100.435 134.27 98.8848 132.661 97.7811 130.763C98.6537 132.797 98.7656 135.939 98.7124 137.255C98.6752 137.616 98.5959 138.603 98.5756 139.667C98.5554 140.731 99.0335 141.989 99.275 142.485C99.5128 143.237 99.6488 144.845 98.2908 145.26C96.9328 145.676 96.1304 144.178 95.899 143.378C95.7816 142.839 95.8604 140.901 97.115 137.462Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M99.8817 139.423C99.8816 136.697 99.0775 133.698 98.6755 132.539C99.7853 134.936 100.794 135.838 102.187 137.649C103.302 139.098 103.83 140.394 103.988 140.849L104.081 141.304C104.006 143.333 102.655 143.607 101.989 143.49C101.286 143.27 99.8818 142.149 99.8817 139.423Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M52.0001 11.5369C50.7955 14.9944 51.1187 17.4494 51.431 18.2448C50.6847 17.2809 48.614 15.1856 46.3015 14.5158C43.989 13.8459 41.8214 11.8558 40.974 10.9985C40.4129 10.2237 40.2926 8.5198 41.5771 8.05318C42.8616 7.58656 43.7549 8.66014 44.041 9.25526C44.2486 9.76241 44.8566 11.0002 45.6288 11.8941C46.4009 12.788 47.5853 13.8164 48.0811 14.2188C48.7264 14.7766 50.2999 16.3628 51.431 18.2448C50.529 16.2236 50.3717 13.0838 50.4058 11.7665C50.4377 11.4054 50.5028 10.4171 50.5076 9.35279C50.5125 8.28849 50.0163 7.03803 49.7676 6.54584C49.519 5.7973 49.3597 4.19144 50.7115 3.75628C52.0634 3.32112 52.8873 4.8067 53.1303 5.60388C53.2555 6.14094 53.2047 8.07943 52.0001 11.5369Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M49.2052 9.6162C49.2448 12.3421 50.0922 15.3291 50.5109 16.4818C49.3666 14.1014 48.3452 13.2141 46.9256 11.423C45.7899 9.99006 45.2428 8.70217 45.0783 8.2493L44.9789 7.79607C45.0245 5.76628 46.3718 5.47257 47.0398 5.57944C47.7451 5.78924 49.1657 6.89031 49.2052 9.6162Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M80.0489 141.162C82.151 138.164 82.5096 135.714 82.4262 134.864C82.8812 135.994 84.3018 138.575 86.3439 139.85C88.386 141.126 89.9287 143.631 90.51 144.687C90.8385 145.586 90.4895 147.258 89.1264 147.357C87.7633 147.455 87.1967 146.179 87.0838 145.528C87.0225 144.983 86.7751 143.627 86.2761 142.556C85.7771 141.485 84.918 140.173 84.5509 139.651C84.0822 138.938 83.001 136.983 82.4262 134.864C82.7426 137.054 82.0375 140.118 81.6454 141.376C81.5162 141.714 81.184 142.648 80.889 143.67C80.5941 144.693 80.7303 146.031 80.8354 146.573C80.8704 147.361 80.5856 148.949 79.1663 148.999C77.747 149.049 77.3595 147.395 77.3432 146.562C77.3692 146.011 77.9469 144.16 80.0489 141.162Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M82.2139 143.772C82.9194 141.139 82.9189 138.034 82.8304 136.811C83.2821 139.413 84.0227 140.545 84.8999 142.656C85.6017 144.344 85.7767 145.732 85.8115 146.213L85.7835 146.676C85.186 148.616 83.8096 148.531 83.1961 148.246C82.5748 147.852 81.5084 146.405 82.2139 143.772Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M69.063 7.85119C67.0046 10.8791 66.6814 13.3341 66.7772 14.1832C66.3058 13.059 64.848 10.4992 62.7876 9.25366C60.7273 8.00809 59.1486 5.52477 58.552 4.47741C58.2106 3.58376 58.5353 1.90678 59.8969 1.78851C61.2584 1.67025 61.8434 2.93845 61.9657 3.58733C62.0349 4.13091 62.3019 5.48389 62.8163 6.54718C63.3308 7.61047 64.2087 8.91038 64.5834 9.42742C65.0624 10.1333 66.1717 12.0726 66.7772 14.1832C66.429 11.9975 67.0898 8.92393 67.4636 7.66037C67.5879 7.31982 67.9066 6.38202 68.1867 5.35523C68.4669 4.32845 68.3112 2.99217 68.1984 2.45238C68.152 1.665 68.4137 0.0726366 69.8322 0.00218811C71.2506 -0.0682604 71.6619 1.57995 71.6903 2.41286C71.6722 2.96402 71.1215 4.82331 69.063 7.85119Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(8 8)",
    d: "M66.8605 5.27258C66.1932 7.91582 66.2386 11.0203 66.3448 12.2422C65.8555 9.64668 65.0986 8.52531 64.1909 6.42778C63.4648 4.74975 63.2697 3.36414 63.228 2.88413L63.2493 2.42062C63.8187 0.471779 65.1961 0.536793 65.8136 0.812906C66.4407 1.19811 67.5279 2.62934 66.8605 5.27258Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_113_11492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5 74.5) rotate(90) scale(74.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BEBA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC0",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChakra);
export default __webpack_public_path__ + "static/media/chakra.811deae63956ee9e10b784adc6cb1e7a.svg";
export { ForwardRef as ReactComponent };